{
    "Api tokens": {
        "add token": "Dodaj token",
        "description": "Generuje token API do pobierania plików OEM dla TCT i Konfiguratora lub token API do wykorzystania przez aplikację podczas żądania usług FOTA WEB. Dokumentacja API znajduje się <1>tutaj</1>.",
        "example": "Np.: fota_token",
        "generate token": "Wygeneruj tokenu",
        "generated token": "Wygenerowany token",
        "last used at": "Ostatnio używany w",
        "name": "Nazwa tokenu",
        "never": "Nigdy",
        "no tokens": "Brak dostępnych tokenów",
        "no tokens description": "Po dodaniu tokenów zostaną one wyświetlone poniżej",
        "show token list": "Pokaż listę tokenów",
        "titles": {
            "Integration": {
                "description": "Służy do integracji FOTA WEB w Twoim systemie",
                "name": "Token integracji API"
            },
            "Tct": {
                "description": "Służy do pobierania plików OEM dla TCT i Konfiguratora",
                "name": "Token TCT"
            }
        },
        "tokens": "Tokeny API",
        "token type": "Typ tokenu",
        "token was created": "Token został pomyślnie utworzony"
    },
    "Attributes": {
        "Completed": "Ukończone",
        "Count": "Liczba",
        "Current": "Aktualny",
        "Date": "Data",
        "Empty": "Puste",
        "excluded files": "Pliki wykluczone (samegrade)",
        "Failed": "Nie powiodło się",
        "false": "",
        "Feature": "Funkcja",
        "file size bytes": "Całkowity rozmiar plików",
        "File_type": "Typ pliku",
        "File_version": "Wersja pliku",
        "Fingerprint_id": "Identyfikacja odcisków palców",
        "Firmware_date": "Data firmware",
        "Firmware_version": "Wersja firmware",
        "included files": "Dołączone pliki",
        "Include_j1939": "",
        "Message": "Wiadomość",
        "Metadata": "",
        "newest": "Od najnowszego",
        "oldest": "Od najstarszego",
        "Order": "Zamów",
        "Password_source": "",
        "Pending": "W toku",
        "Period": "Okres",
        "Process_id": "",
        "Protocol_id": "Identyfikator protokołu",
        "Reported_count": "",
        "Requested_count": "",
        "specific": "Szczegółowe informacje",
        "Start": "Start",
        "SystemGenerated": "",
        "true": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "Firmware BLE",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "Firmware CAN",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "Firmware TAPP"
        },
        "UserEntered": "",
        "vehicle": "Pojazd",
        "Vehicle_id": "Identyfikator pojazdu",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "Sprawdź swoją aplikację uwierzytelniającą",
            "check email": "Sprawdź swój email",
            "code required": "Wymagany kod weryfikacyjny.",
            "code sent to email": "Kod wysłany na Twój adres e-mail",
            "code valid": "Kod jest ważny przez kilka minut.",
            "enter code below": "i wprowadź poniższy kod, aby się zalogować.",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "Wymagany kod weryfikacyjny. Sprawdź swoją aplikację uwierzytelniającą i wprowadź poniższy kod, aby się zalogować.",
        "check email": "Sprawdź swoją skrzynkę odbiorczą i kliknij otrzymany link, aby zresetować hasło.",
        "community forum": "Forum wsparcia społecznościowego",
        "contact us": "Skontaktuj się z nami",
        "create initial password": "Utwórz hasło",
        "create password": "Utwórz hasło, które",
        "did not receive": "Nie otrzymałeś linku?",
        "do not have account": "Nie masz jeszcze konta?",
        "email": "E-mail",
        "enter email": "Wpisz poniżej swój zarejestrowany adres e-mail, aby otrzymać instrukcje dotyczące resetowania hasła.",
        "forgot password": "Nie pamiętasz hasła?",
        "forgot your password": "Nie pamiętasz swojego hasła?",
        "for ms365": "Dla użytkowników Teltonika MS365",
        "invalid email format": "Nieprawidłowy format adresu e-mail",
        "invalid password format": "Nieprawidłowy format hasła",
        "link sent": "Link został wysłany!",
        "length": "Minimum 8 znaków",
        "lowercase": "Zawiera co najmniej 1 małą literę",
        "new password": "Nowe hasło",
        "password": "Hasło",
        "passwords do not match": "Hasła nie pasują",
        "privacy policy": "Korzystając z FOTA WEB, wyrażasz zgodę na naszą <1>Politykę prywatności</1>.",
        "remember password": "Pamiętasz swoje hasło?",
        "repeat password": "Powtórz hasło",
        "required": "Wymagane",
        "resend": "Wyślij ponownie",
        "reset password": "Zresetuj hasło",
        "send reset link": "Wyślij link resetujący",
        "sign in": "Zaloguj się",
        "sign in to fota": "Zaloguj się na swoje konto FOTA WEB",
        "signup": "Zarejestruj się",
        "sso": "Zaloguj się za pomocą konta Microsoft",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Wielka litera",
        "user consent text": "Rozumiem i akceptuję <1>Warunki świadczenia usług</1> firmy Teltonika oraz <2>Umowę o przetwarzaniu danych</2>.",
        "welcome": "Witamy w",
        "wiki": "Baza wiedzy Telematics Wiki"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "Akceptuj",
        "accept all": "Akceptuj wszystko",
        "accept selected": "Akceptuj wybrane",
        "actions": "Działania",
        "add": "Dodaj",
        "add device": "Dodaj urządzenie",
        "add more files": "Dodaj więcej plików",
        "add new": "Dodaj nowe",
        "agree": "Zgadzam się",
        "all companies": "Wszystkie firmy",
        "all of company": "Wszystkie {{companyName}}",
        "all rows selected": {
            "devices": "Wszystkie {{count}} urządzenia są wybrane",
            "tasks": "Wszystkie {{count}} zadania oczekujące/w trakcie realizacji są zaznaczone",
            "groups": "Wszystkie {{count}} grupy są zaznaczone",
            "files": "Wszystkie {{count}} pliki zostały wybrane",
            "companies": "Wszystkie {{count}} firmy zostały wybrane",
            "users": "Wybrano wszystkich {{count}} użytkowników"
        },
        "approve": "Zatwierdź",
        "assign": "Przypisz",
        "assigning": "Przypisywanie",
        "auto sync": "",
        "back": "Powrót",
        "back to sign in": "Powrót do logowania",
        "cancel": "Anuluj",
        "cancelling": "Anulowanie",
        "cancel all tasks in group": "Anuluj wszystkie zadania w grupie",
        "cancel tasks": "Anuluj zadania",
        "cannot create desktop licenses": "Nie można tworzyć licencji dla firm wewnętrznych.",
        "cannot create offline licenses": "Nie można tworzyć licencji offline dla licencji bez ograniczeń.",
        "change": "Zmiana",
        "clear all": "Wyczyść wszystko",
        "clear all filters": "Wyczyść wszystkie filtry",
        "close": "Zamknij",
        "company settings": "Ustawienia firmy",
        "confirm": "Potwierdź",
        "continue": "Kontynuuj",
        "copied": "Skopiowano",
        "copy all": "",
        "copy to clipboard": "Kopiuj do schowka",
        "create": "Utwórz",
        "create role": "Utwórz rolę",
        "create task": "Utwórz zadanie",
        "creating": "Tworzenie",
        "default view": "Widok domyślny",
        "delete": "Usuń",
        "deleting": "Usuwanie",
        "deselect all": "Odznacz wszystko",
        "device": "Urządzenie",
        "disable": "Wyłącz",
        "disagree": "Nie zgadzam się",
        "discard": "Odrzuć",
        "download": "",
        "edit": "Edytuj",
        "enable": "Włącz",
        "export": "Eksport",
        "exporting": "Eksportowanie",
        "filters": "Filtry",
        "finish": "",
        "find tool": "Narzędzie wyszukiwania",
        "first page": "Pierwsza strona",
        "generate": "Generuj",
        "generate codes": "",
        "go back": "Wróć",
        "import": "Import",
        "importing": "Importowanie",
        "invite": "Zaproś",
        "invite user": "Zaproś użytkownika",
        "invite user to internal disabled": "Tylko administratorzy i osoby z wyższymi uprawnieniami mogą zapraszać użytkowników do wewnętrznych firm.",
        "language": "Język",
        "last page": "Ostatnia strona",
        "logout": "Wyloguj się",
        "maximize details": "Maksymalizacja szczegółów",
        "merge": "Scal",
        "merging": "Łączenie",
        "minimize details": "Zminimalizuj szczegóły",
        "more actions": "Więcej działań",
        "more filters": "Więcej filtrów",
        "more options": "Więcej opcji",
        "move": "Przenieś",
        "moving": "Przenoszenie",
        "next": "Dalej",
        "next month": "W przyszłym miesiącu",
        "next page": "Następna strona",
        "no actions available": "Brak dostępnych działań",
        "no permission": "Potrzebujesz uprawnienia „{{permissionName}}”.",
        "no permissions": "Potrzebujesz następujących uprawnień: {{permissionNames}}.",
        "notify when done": "Powiadom mnie po zakończeniu",
        "number of selected companies": "{{companyCount}} z {{companyName}}",
        "only essential": "Tylko niezbędne",
        "open fota web": "Otwórz FOTA WEB",
        "pages of": "z {{total}}",
        "previous month": "Poprzedni miesiąc",
        "previous page": "Poprzednia strona",
        "print": "",
        "receive devices": "Odbierz urządzenia",
        "refresh page": "Odśwież",
        "reject all": "Odrzuć wszystko",
        "reset to default": "Przywróć ustawienia domyślne",
        "retry failed tasks": "Ponowna próba wykonania nieudanych zadań",
        "retrying": "Ponowna próba",
        "return home": "Powrót do strony głównej",
        "revert manual level change": "Przywróć ręczną zmianę poziomu",
        "rows count per page": "Liczba wierszy na stronie",
        "rows selected": "{{count}} Wybrane",
        "save": "Zapisz",
        "saving": "",
        "see all": "Zobacz wszystkie",
        "select all": {
            "devices": "Wybierz wszystkie {{count}} urządzenia",
            "tasks": "Wybierz wszystkie {{count}} zadania oczekujące/w trakcie realizacji",
            "groups": "Wybierz wszystkie {{count}} grupy",
            "files": "Zaznacz wszystkie {{count}} pliki",
            "companies": "Wybierz wszystkie {{count}} firmy",
            "users": "Wybierz wszystkich {{count}} użytkowników"
        },
        "select columns to show": "Wybierz kolumny do wyświetlenia",
        "selected page is first": "Wybrana strona jest pierwszą stroną",
        "selected page is last": "Wybrana strona jest ostatnią stroną",
        "select rows": "Wybierz wiersze",
        "send code": "Wyślij kod",
        "settings": "Ustawienia",
        "show me": "Pokaż mi",
        "show more": "Pokaż więcej",
        "synchronize": "Synchronizacja",
        "table statistics": "Statystyki tabel",
        "table view": "Widok tabelaryczny",
        "transfer": "Transfer",
        "transferring": "Przenoszenie",
        "transfer my devices": "Przenieś moje urządzenia",
        "undo": "Cofnij",
        "upload": "Przesyłanie",
        "upload file": "Prześlij nowy plik",
        "user": "Użytkownik",
        "verify": "Weryfikacja",
        "yes": "Tak"
    },
    "Cookies": {
        "always active": "Zawsze aktywny",
        "analytics cookies": "Analityczne pliki cookie",
        "analytics cookies description": "Te pliki cookie są używane do analizy danych, które pozwalają nam zrozumieć, jak użytkownicy korzystają z naszych stron internetowych. Dzięki tym informacjom możemy ulepszać treści i tworzyć lepsze funkcje, które poprawiają komfort użytkowania. Tę kategorię plików cookie można wyłączyć.",
        "cookie banner message": "My i wybrane strony trzecie używamy plików cookie lub podobnych technologii do celów technicznych oraz, za Twoją zgodą, do innych celów określonych w ",
        "cookie modal title": "Używamy plików cookie",
        "cookie policy": "polityka plików cookie",
        "essential cookies": "Niezbędne pliki cookie",
        "essential cookies description": "Te pliki cookie są używane do zadań, które są absolutnie niezbędne do działania lub dostarczania usług, o które nas poprosiłeś, i nie zbierają informacji o Tobie, które mogłyby być wykorzystane do celów marketingowych, ani nie zapamiętują, gdzie byłeś w Internecie. Te pliki cookie nie mogą być wyłączone."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "Niezbędne elementy do zdalnej aktualizacji urządzeń",
                "Standard": "Zaawansowana automatyzacja i integracja",
                "Premium": "Skalowanie dla przedsiębiorstw i wczesny dostęp do aktualizacji"
            },
            "resource limit types": {
                "Companies": "Firmy",
                "Users": "Użytkownicy",
                "ConfigurationFiles": "Pliki konfiguracyjne"
            }
        },
        "empty state": {
            "description": {
                "configurations": "Gdy tylko konfiguracje zostaną wykryte przez FOTA WEB, lista będzie widoczna tutaj.",
                "firmware versions": "Gdy tylko wersje firmware zostaną wykryte przez FOTA WEB, lista będzie dostępna tutaj."
            },
            "title": {
                "configurations": "Nie wykryto żadnych konfiguracji",
                "firmware versions": "Nie wykryto żadnych wersji firmware",
                "news": "Brak aktualności do wyświetlenia"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "Dzisiaj",
                "7": "7 dni",
                "30": "30 dni",
                "90": "90 dni"
            },
            "period": "Okres"
        },
        "new": "",
        "news": {
            "body": {
                "1": "Przypominamy, że dla użytkowników zaproszonych po 7 stycznia 2025 r. uwierzytelnianie dwuetapowe będzie obowiązkowe natychmiast po aktywacji konta. Uwierzytelnianie dwuetapowe jest dostępne poprzez weryfikację e-mail lub aplikację uwierzytelniającą.",
                "2": "Pragniemy poinformować Państwa o planowanej konserwacji FOTA WEB, która odbędzie się 3 czerwca 2025 r. o godz. 05:00 czasu UTC. Prosimy pamiętać, że podczas konserwacji wszystkie usługi będą niedostępne, w tym interfejs użytkownika, dostęp do API, wykonywanie zadań, usługi OBD i CAN. Szacowany czas niedostępności usług wynosi 1 godzinę.",
                "3": "<section><p>Z radością ogłaszamy ważne ulepszenie funkcji Device Unlocker w FOTA WEB:</p></section> <section><p>Wszystkie role użytkowników mogą teraz odblokowywać urządzenia bezpośrednio — nie ma potrzeby kontaktowania się z pomocą techniczną za pośrednictwem Helpdesku!</p> <p>Najważniejsze informacje:</p> <ul><li>Użytkownicy mogą odblokować to samo urządzenie maksymalnie 3 razy w ciągu 24 godzin.</li> <li>Po osiągnięciu limitu opcja odblokowania zostanie tymczasowo wyłączona na 24 godziny. </li> <li>W przypadku przekroczenia limitu odblokowań pojawi się komunikat o błędzie. Ta aktualizacja znacznie skraca czas oczekiwania i zapewnia większą kontrolę nad zarządzaniem flotą. </li></ul></section> <section><a>Dowiedz się, jak korzystać z tej funkcji</a></section>",
                "4": "<section><p>Z radością ogłaszamy kilka wspaniałych nowych aktualizacji pulpitu nawigacyjnego FOTA WEB! Pracowaliśmy nad poprawą komfortu użytkowania dzięki ulepszonym widżetom i nowym funkcjom analitycznym. </p></section> <section><h3>Nowe statystyki urządzeń</h3> <p>Uzyskaj lepszy wgląd w aktywność swoich urządzeń dzięki dwóm zupełnie nowym widżetom:</p> <p><strong>Aktywowane urządzenia</strong>: Ta nowa statystyka pokazuje, ile urządzeń zostało aktywowanych (podłączonych) w różnych okresach: dzisiaj, 7 dni, 30 dni lub 90 dni. </p> <p><strong>Zaimportowane urządzenia</strong>: Podobnie, nowa statystyka zaimportowanych urządzeń śledzi, ile urządzeń zostało zaimportowanych dzisiaj, 7 dni, 30 dni lub 90 dni.</p> </section> <section><h3>Przedstawiamy widżet zadań</h3> <p>Śledź swoje operacje dzięki całkowicie nowemu widżetowi zadań:</p> <p><strong>Zadania w kolejce</strong>: Zobacz przejrzystą liczbę zadań oczekujących na realizację.</p> <p><strong>Przegląd zadań</strong>: Uzyskaj zestawienie zadań według okresu (7 dni, 30 dni lub 90 dni) i statusu. Obejmuje to zadania, które zostały ukończone, ukończone z błędami lub nie powiodły się.</p></section> <section><h3>Inteligentniejsze przeglądy firmware i konfiguracji</h3> <p>Udoskonaliliśmy widżety wersji firmware i konfiguracji:</p> <ul><li>Usunęliśmy statystyki „Nieznane”, aby uzyskać bardziej przejrzyste dane.</li> <li>UI teraz bardziej wyraźnie pokazuje nazwy firmware i konfiguracji oraz ich liczbę.</li> <li>Początkowo wyświetlane jest 5 najpopularniejszych wersji lub konfiguracji, z opcją „Pokaż więcej”, która pozwala wyświetlić do 100 różnych wpisów. </li> <li>Najechanie kursorem i kliknięcie konkretnego firmware lub konfiguracji spowoduje przejście do strony „Urządzenia” i zastosowanie filtra.</li></ul></section> <section><h3>Ulepszony widget wiadomości</h3> <p>Bądź na bieżąco! Widget wiadomości ma nowy wygląd, a teraz można również kliknąć dowolną wiadomość, aby przeczytać pełną informację. </p></section> <section><h3>Ulepszony status urządzenia</h3> <p>Widget statusu urządzenia został wizualnie zaktualizowany w celu zwiększenia przejrzystości. Ponadto można teraz najechać kursorem na status urządzenia i kliknąć go, aby odfiltrować urządzenia o odpowiednim statusie na stronie „Urządzenia”.</p></section> <section><p>Mamy nadzieję, że te aktualizacje ułatwią codzienne zadania i zapewnią bardziej wartościowe informacje. Prosimy o opinie!</p></section>",
                "5": "<section><h3>Planowane zmiany w API</h3></section> <section><p>W dniu <strong>24 września 2025 r.</strong> usuniemy pole „role” z odpowiedzi zwracających encję użytkownika (na przykład punkty końcowe GET /users lub GET /users/{userId}). Zmiana ta ma na celu przygotowanie gruntu pod bardziej niezawodny i elastyczny system uprawnień w FOTA WEB.</p></section> <section><h3>Zapowiedź: role i uprawnienia</h3></section> <section><p> Zdajemy sobie sprawę, że obecny system ról nie zapewnia wymaganej elastyczności. Nasz zespół programistów intensywnie pracuje nad nową funkcją <strong>zarządzania rolami i uprawnieniami</strong>, która pozwoli na tworzenie ról z precyzyjną kontrolą nad uprawnieniami.</p></section> <section><p>Ten nowy system da Ci możliwość przypisywania statycznych ról użytkownikom lub dostosowywania uprawnień do konkretnych potrzeb oraz tworzenia niestandardowych ról. Jesteśmy tym bardzo podekscytowani i nie możemy się doczekać, aby podzielić się więcej szczegółami na temat zarządzania rolami i uprawnieniami, gdy tylko będą one dostępne.</p></section>",
                "6": "<section><p>Z przyjemnością ogłaszamy wprowadzenie nowej funkcji <strong>„Role i uprawnienia”</strong>, zaprojektowanej w celu zapewnienia precyzyjnej kontroli nad dostępem użytkowników w ramach FOTA WEB. Funkcja ta pozwala definiować uprawnienia użytkowników za pomocą <strong>ról</strong>, które są zestawami określonych <strong>uprawnień</strong> (np. „Utwórz zadanie”, „Zaproś użytkownika”). Funkcja obejmuje niezmienne <strong>role statyczne</strong> — administrator, użytkownik i gość — zapewniające podstawowe bezpieczeństwo, a także konfigurowalne <strong>role niestandardowe</strong>, które mogą tworzyć lub edytować wyłącznie użytkownicy <strong>na poziomie firmy Premium</strong>. Uprawnienia są teraz podzielone na kluczowe obszary, takie jak urządzenia, zadania i użytkownicy, i można je wyświetlić, najeżdżając kursorem na „liczbę uprawnień” w sekcji zarządzania. <strong>Wszystkim użytkownikom utworzonym przed tą aktualizacją automatycznie przypisano rolę „Administrator”, dzięki czemu zachowali oni pełen zakres działań, które mogli wykonywać wcześniej. </strong></p></section> <section><p>Ta aktualizacja zapewnia większe bezpieczeństwo i lepszy rozkład obciążenia pracą. Role są teraz specyficzne dla danej firmy i nie mogą być dziedziczone w ramach struktur firmowych. Należy pamiętać, że rola musi być zawsze przypisana podczas zapraszania lub przenoszenia użytkownika do firmy, a role z aktywnymi przypisaniami użytkowników nie mogą być usuwane. Aby ułatwić zarządzanie, można teraz używać <strong>nowego filtra „Rola”</strong> na stronie <strong>Użytkownicy</strong>. Zapoznaj się z sekcją „Role i uprawnienia”, aby skonfigurować dostęp dostosowany do potrzeb Twojej organizacji.</p></section> <section><p>Szczegółowy przewodnik dotyczący zarządzania użytkownikami i rolami można znaleźć na <a>stronie wiki</a>.</p></section>",
                "7": "<section><p>Z radością wprowadzamy nową, potężną funkcję zarządzania zadaniami – <strong>Harmonogram według daty</strong>, która zapewnia większą precyzję w przypadku zadań wymagających terminowości!</p></section> <section><h3>Najważniejsze cechy</h3></section> <section><ul><li><strong>Konkretne terminy</strong> — teraz możesz planować zadania na <strong>konkretną datę lub przedział czasowy</strong> za pomocą nowej opcji „Planuj według daty”.</li> <li><strong>Niezmienione domyślne zachowanie</strong> — znana funkcja <strong>Planowanie według czasu</strong> pozostaje w pełni dostępna. </li> <li><strong>Status wygaśnięcia</strong> — zadania, które nie zostały ukończone w ustalonym terminie, będą teraz automatycznie zmieniać status na <strong>Wygasłe</strong>, wraz z komunikatem: <strong>„Zadanie nie zostało ukończone w ustalonym terminie”.</strong></li> <li><strong>Czas dostosowany do użytkownika</strong> — wszystkie harmonogramy są tworzone na podstawie <strong>czasu lokalnego</strong>.</li></ul></section> <section><h3>Jak to działa</h3></section> <section><p>Podczas ustawiania zadania <strong>„Harmonogram według daty”</strong>:</p> <ul><li>Za pomocą komponentu wyboru daty wybierzesz <strong>„Datę rozpoczęcia”</strong> i <strong>„Datę zakończenia”</strong>.</li> <li>Komponent wyboru daty uwzględnia limit czasu wygaśnięcia zadania na poziomie firmy.</li></ul></section><section><p>Funkcja <strong>Planuj według daty</strong> jest obecnie dostępna wyłącznie dla wyższych poziomów firmy i nie jest dostępna dla poziomu <strong>Podstawowego</strong>.</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "Obowiązkowa uwierzytelnianie dwuskładnikowe (2FA) dla nowych użytkowników od 7 stycznia 2025 r",
                "2": "Planowana konserwacja 3 czerwca 2025 r",
                "3": "Nowa aktualizacja funkcji: łatwiejsze odblokowywanie urządzeń dla wszystkich użytkowników",
                "4": "Odkryj nowości na swoim pulpicie nawigacyjnym!",
                "5": "Ważne: nadchodzące zmiany w API oraz zapowiedź ról i uprawnień",
                "6": "Nowa funkcja już dostępna: ulepszona kontrola dzięki „rolom i uprawnieniom”",
                "7": "Nowa funkcja: większa elastyczność dzięki harmonogramowi zadań według daty",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "Opublikowano",
        "take me there": "Przenieś mnie tam",
        "tasks": {
            "current": "Aktualny",
            "status": {
                "completed": "Ukończone",
                "completed_with_errors": "Ukończono z błędami",
                "failed": "Nie powiodło się",
                "no tasks": "Brak zadań"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7 dni",
                "tooltipTitle": "Ostatnie 7 dni"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30 dni",
                "tooltipTitle": "Ostatnie 30 dni"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90 dni",
                "tooltipTitle": "Ostatnie 90 dni"
            }
        },
        "title": {
            "activated": "Aktywowane urządzenia",
            "configurations": "Konfiguracje",
            "device status": "Status urządzenia",
            "firmware versions": "Wersje firmware",
            "imported": "Zaimportowane urządzenia",
            "news": "Aktualności",
            "queued tasks": "Zadania w kolejce",
            "refreshed every hour": "aktualizowany co godzinę",
            "resource limits": "Limity zasobów",
            "task overview": "Przegląd zadań",
            "tasks": "Zadania"
        },
        "tooltips": {
            "activated": "Liczba urządzeń, które po raz pierwszy połączyły się z FOTA WEB w wybranym okresie (dzisiaj, ostatnie 7 dni, ostatnie 30 dni, ostatnie 90 dni).",
            "configurations": "Pokazuje rozkład nazw plików konfiguracyjnych, które zostały przesłane do urządzeń. Wyświetla się maksymalnie 100 unikalnych nazw plików.",
            "firmware versions": "Wyświetla rozkład wersji firmware zgłoszonych przez podłączone urządzenia. Wyświetla do 100 unikalnych wersji.",
            "imported": "Liczba urządzeń dodanych do konta w wybranym okresie (dzisiaj, ostatnie 7 dni, ostatnie 30 dni, ostatnie 90 dni)."
        }
    },
    "Date picker": {
        "disableFuture": "Nieprawidłowa data",
        "disablePast": "Nieprawidłowa data",
        "invalidDate": "Nieprawidłowa data",
        "maxDate": "Nieprawidłowa data",
        "minDate": "Nieprawidłowa data",
        "shouldDisableDate": "Nieprawidłowa data",
        "shouldDisableMonth": "Nieprawidłowa data",
        "shouldDisableYear": "Nieprawidłowa data"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "Dodaj nowe urządzenie",
        "add new device description": "Dodaj jedno lub wiele nowych urządzeń do wybranej firmy i grupy. Tylko urządzenia starszego typu, takie jak FM lub FMA, muszą być importowane poprzez zaznaczenie pola wyboru „Importuj jako urządzenia starszego typu”.",
        "add new device legacy title": "Importuj jako starsze urządzenia.",
        "add new device legacy description": "Ustaw „Utworzono” na 2016.01.01, a „Model” na Legacy.",
        "add new product code": "Dodaj nowy kod produktu",
        "add new product code description": "Dodaj nowy kod produktu urządzenia i połącz go z dostępnym pakietem CAN.",
        "all permissions": "Wszystkie uprawnienia",
        "assign access group": "",
        "assign can package description": "Wybierz typ pakietu i przypisz go do wszystkich wybranych urządzeń.",
        "assign role": "Przypisywanie ról",
        "attribute value": "Wartość atrybutu",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "Rozpocznij pobieranie",
        "by date": "Według daty",
        "by time": "Według czasu",
        "can adapter": "Adapter CAN",
        "cancel pending tasks": "Anuluj oczekujące zadania tego samego typu",
        "cancel tasks": "Anuluj zadania",
        "cancel tasks in group": {
            "alert title": "Wykonanie tej czynności może potrwać kilka minut.",
            "banner description": "Aby zobaczyć zaktualizowany status zadań, zapoznaj się ze szczegółami grupy zadań lub odśwież stronę.",
            "banner title": "Wykonanie tej czynności może potrwać do kilku minut, w zależności od liczby zadań.",
            "description": "Kliknięcie „Akceptuj” spowoduje anulowanie wszystkich oczekujących i uruchomionych zadań. Czy na pewno chcesz kontynuować?",
            "title": "Anulować wszystkie zadania w grupie?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "E-mail przedstawiciela klienta",
        "companies": "Firmy",
        "company": "Firma",
        "company level": {
            "Basic": "Podstawowy",
            "Internal": "Wewnętrzny",
            "Premium": "Premium",
            "Standard": "Standard"
        },
        "company level change description": "Aby podwyższyć poziom firmy, wybierz nowy poziom i podaj uzasadnienie. Obniżenie poziomu firmy nie jest możliwe. Wszystkie daty podane są w czasie UTC.",
        "company level manual revert": {
            "confirmation": {
                "description": "Ta czynność spowoduje przywrócenie poziomu firmy do automatycznie przypisanego poziomu „{{companyLevel}}”. Czy na pewno chcesz kontynuować?",
                "title": "Cofnąć ręczną zmianę poziomu?"
            },
            "description": "Przywrócenie spowoduje zmianę poziomu firmy z powrotem do poziomu przypisanego automatycznie.",
            "title": "Ten poziom firmy był aktualizowany ręcznie do dnia {{expirationDate}}."
        },
        "company level type": "Typ poziomu firmy",
        "company name": "Nazwa firmy",
        "company statistics": {
            "child companies": "Liczba spółek zależnych",
            "devices": "Liczba urządzeń",
            "files": "Liczba plików",
            "groups": "Liczba grup urządzeń",
            "tasks": "Liczba zadań",
            "users": "Liczba użytkowników"
        },
        "company type": {
            "All": "",
            "Client": "Klient",
            "Internal": "Wewnętrzny",
            "Virtual": "Wirtualny"
        },
        "configuration": "Konfiguracja",
        "confirmations": {
            "are you sure": "Czy na pewno?",
            "are you sure you wish to continue": "Czy na pewno chcesz kontynuować?",
            "assign can package confirmation": "Czy na pewno chcesz przypisać wybrany pakiet do określonej liczby urządzeń?",
            "cancel task confirmation": {
                "first part": "Czy na pewno chcesz anulować określoną liczbę zadań?",
                "second part": "Jeśli tak, wprowadź liczbę zadań, których to dotyczy, i kliknij „Potwierdź”."
            },
            "create task confirmation": "Czy na pewno chcesz utworzyć zadanie dla określonej liczby urządzeń?",
            "delete resource confirmation": {
                "first part": "Czy na pewno chcesz usunąć określoną liczbę {{resource}}?",
                "second part": "Jeśli tak, wprowadź liczbę dotkniętych {{resource}} i kliknij „Usuń”."
            },
            "delete resources": {
                "companies": "firmy",
                "files": "pliki",
                "groups": "grupy urządzeń",
                "deviceModels": "modele",
                "productCodes": "kody produktów",
                "roles": "role",
                "users": "użytkownicy"
            },
            "description second part": "Jeśli tak, wprowadź liczbę urządzeń, których to dotyczy, i kliknij „Potwierdź”.",
            "export device data confirmation": "Czy na pewno chcesz wyeksportować dane urządzeń dla określonej liczby urządzeń?",
            "file": "Wprowadź liczbę wierszy istniejących w pliku",
            "filter": {
                "companies": "Wprowadź liczbę przefiltrowanych firm",
                "devices": "Wprowadź liczbę filtrowanych urządzeń",
                "files": "Wprowadź liczbę przefiltrowanych plików",
                "groups": "Wprowadź liczbę przefiltrowanych grup urządzeń",
                "productCodes": "Wprowadź liczbę przefiltrowanych kodów produktów",
                "tasks": "Wprowadź liczbę przefiltrowanych zadań",
                "users": "Wprowadź liczbę filtrowanych użytkowników"
            },
            "id_list": {
                "companies": "Wprowadź liczbę wybranych firm",
                "devices": "Wprowadź liczbę wybranych urządzeń",
                "files": "Wprowadź liczbę wybranych plików",
                "groups": "Wprowadź liczbę wybranych grup urządzeń",
                "productCodes": "Wprowadź liczbę wybranych kodów produktów",
                "tasks": "Wprowadź liczbę wybranych zadań",
                "users": "Wprowadź liczbę wybranych użytkowników"
            },
            "merge companies confirmation": "Zamierzasz połączyć firmy {{sourceCompany}} i {{targetCompany}}.",
            "move companies confirmation": "Zamierzasz przenieść {{sourceCompany}} do firmy {{targetCompany}}.",
            "move devices confirmation": "Czy na pewno chcesz przenieść określoną liczbę urządzeń do innej firmy?",
            "number of lines": "Liczba linii",
            "selected 20 or more devices": "Wybrano 20 lub więcej urządzeń...",
            "transfer devices confirmation": "Czy na pewno chcesz przenieść określoną liczbę urządzeń do innej firmy?"
        },
        "confirm cannot revert": "Ta czynność jest nieodwracalna.",
        "confirm merge companies": "Czy na pewno chcesz połączyć te firmy?",
        "count": "Liczba",
        "create company": "Utwórz firmę",
        "create company description": "Utwórz nową firmę w ramach wybranej firmy macierzystej.",
        "create desktop license": "Utwórz licencję desktop",
        "create desktop license description": "Wydaj nową licencję online FOTA Desktop dla firmy klienta z jej adresem IP, kluczem sprzętowym i datą wygaśnięcia (maksymalnie 2 lata).",
        "create group": "Utwórz grupę",
        "create group description": "Organizuj urządzenia w grupy, aby uprościć zarządzanie i przypisywanie zbiorcze.",
        "create model": "Utwórz model",
        "create model description": "Utwórz nowy model urządzenia, określając nazwę, platformę i obsługę TCT web.",
        "create offline license": "Utwórz licencję offline",
        "create or edit group description": "Firmware i konfigurację można przypisać do grupy. Po wykonaniu tej czynności zostaną wygenerowane zadania aktualizacji firmware i/lub konfiguracji dla wszystkich członków grupy (urządzeń).",
        "create role": "Utwórz rolę",
        "create role description": "Utwórz nową rolę, nadając jej nazwę i opis, wybierając firmę i przypisując określone uprawnienia.",
        "create smart group": "Utwórz inteligentną grupę",
        "create smart group banner message": "",
        "create smart group description": "Firmware i pliki konfiguracyjne można przypisać do grupy dla każdej platformy. Po przypisaniu plików zostaną wygenerowane zadania aktualizacji dla wszystkich urządzeń w grupie.",
        "create task description first step": "Twórz różnorodne zadania, od aktualizacji konfiguracji lub firmware po odbieranie logów, konfiguracji i innych danych z wybranych lub przefiltrowanych urządzeń. Ponadto możesz wygodnie planować utworzone zadania.",
        "create task description last step": "Przed utworzeniem zadania upewnij się, że poniższe informacje są poprawne.",
        "current level": "obecny poziom",
        "custom resource limits": {
            "at least one limit must be higher": "Co najmniej jeden limit powinien być wyższy niż domyślna wartość poziomu Premium.",
            "configuration files per device": "Pliki konfiguracyjne dla poszczególnych urządzeń",
            "confirmation modal description": "Czy na pewno chcesz zmienić następujące limity zasobów firmy „{{companyName}}”?",
            "confirmation modal title": "Zmienić limitów zasobów firmy?",
            "count": {
                "companies count": "Liczba firm: {{number}}",
                "configuration files per device count": "Liczba plików konfiguracyjnych na urządzenie: {{number}}",
                "tasks per group count": "Liczba zadań na grupę: {{number}}",
                "users count": "Liczba użytkowników: {{number}}"
            },
            "explanations": {
                "companies": "Całkowita liczba spółek zależnych, które można utworzyć w hierarchii firmy.",
                "configuration files per device": "Liczba plików konfiguracyjnych, które można przechowywać, 1 urządzenie równa się 1 plikowi konfiguracyjnemu. Minimalna gwarantowana liczba plików konfiguracyjnych wynosi 100 dla każdego poziomu firmy.",
                "tasks per group": "Liczba zadań, które mogą znajdować się w jednej grupie zadań.",
                "users": "Całkowita liczba użytkowników, których można utworzyć w hierarchii firmy."
            },
            "main modal description": "Ustaw niestandardową ilość zasobów dla różnych typów zasobów, takich jak firmy, użytkownicy, zadania na grupę zadań lub pliki konfiguracyjne. Niestandardowe zasoby będą aktywne do momentu wygaśnięcia poziomu Premium lub ręcznego zresetowania.",
            "resources limit type": "Typ ograniczenia zasobów",
            "revert custom resource limits": "Przywróć niestandardowe limity zasobów",
            "revert custom resource limits description": "Zresetowanie wszystkich limitów spowoduje ustawienie domyślnych wartości zasobów i zmianę poziomu firmy na Premium.",
            "revert custom resource limits description confirmation": "Ta czynność spowoduje przywrócenie limitów zasobów do wartości automatycznie przypisanych dla poziomu „Premium”. Czy na pewno chcesz kontynuować?",
            "revert custom resource limits title": "Limity zasobów tej firmy zostały ustawione ręcznie.",
            "revert custom resource limits title confirmation": "Przywrócić niestandardowe limity zasobów?",
            "tasks per group": "Zadania według grup"
        },
        "date range": "Zakres dat",
        "date to": "do",
        "delete companies": "Usuń firmy",
        "delete deviceModels": "Usuń modele",
        "delete files": "Usuń pliki",
        "delete file warning": "Usunięcie plików spowoduje anulowanie powiązanych zadań i grup zadań.",
        "delete groups": "Usuń grupy urządzeń",
        "delete productCodes": "Usuń kody produktów",
        "delete roles": "Usuń role",
        "delete tasks and history": "",
        "delete users": "Usuń użytkowników",
        "description": "Opis",
        "desktop license delete description": "Czy na pewno chcesz usunąć licencję desktopową „{{name}}”?",
        "desktop license name": "Nazwa licencji na komputer desktop",
        "device identifier": "Identyfikator urządzenia",
        "device transfer": {
            "main": {
                "description": "Przeniesienie wybranych lub przefiltrowanych urządzeń do niepowiązanej firmy przy użyciu tokenu wygenerowanego przez firmę odbierającą.",
                "title": "Transfer urządzeń"
            },
            "receive devices": {
                "copy token": "Skopiuj i wyślij wygenerowany token do osoby odpowiedzialnej za przeniesienie urządzeń z jej firmy do Twojej.",
                "description": "Utwórz token urządzenia odbiorczego i wyślij go do firmy transferowej.",
                "token info": "Token jest jednorazowego użytku i wygasa po 21 dniach."
            },
            "transfer devices": {
                "confirmation": "Czy na pewno chcesz przenieść urządzenia do poniższej firmy?",
                "device token": "Token transferu urządzenia należy uzyskać od kierownika firmy, do której chcesz przenieść swoje urządzenia.",
                "transfer from file": "Prześlij plik z listą urządzeń (numerami IMEI), które chcesz przenieść ze swojej firmy do firmy, której token właśnie wprowadziłeś."
            }
        },
        "device transfer token": "Token transferu urządzenia",
        "downgrading company level is not possible": "Obniżenie poziomu firmy nie jest możliwe",
        "download sample file message": "Pobierz <1>przykładowy szablon CSV</1>, aby zapoznać się z wymaganym formatem.",
        "edit group banner message": "Zmiana firmware i/lub plików konfiguracyjnych spowoduje anulowanie wszystkich poprzednich zadań tego samego typu.",
        "edit group description": "Zmodyfikuj ustawienia dla tej grupy urządzeń.",
        "edit role description": "Dostosuj nazwę roli, opis i uprawnienia. Przypisanej firmy nie można zmienić.",
        "edit smart group description": "Firmware i pliki konfiguracyjne można przypisywać lub zmieniać dla grupy dla każdej platformy. Po przypisaniu lub zmianie plików zostaną wygenerowane zadania aktualizacji dla wszystkich urządzeń w grupie.",
        "email": "E-mail",
        "enter": "Wejdź",
        "enter code": "Wprowadź kod",
        "enter description": "Wprowadź opis",
        "enter name": "Wprowadź nazwę",
        "example": "Np.:",
        "expires at": "Wygasa o godz",
        "explanation": "Wyjaśnienie",
        "export device data": "Eksport danych z urządzeń",
        "export device description": "",
        "export file format": "Format eksportu plików",
        "feature": "Funkcja",
        "feature control": "Kontrola funkcji",
        "field disabled until company selected": "To pole jest nieaktywne do momentu wybrania firmy.",
        "firmware": "Firmware",
        "files to download": "Pliki do pobrania",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "Przesłana lista autoryzacji 1-Wire zostanie automatycznie posortowana w celu poprawy szybkości i dokładności działania.",
                "bluetooth_authorization_list": "Przesłana lista autoryzacji Bluetooth zostanie automatycznie posortowana w celu poprawy szybkości i dokładności działania."
            },
            "endings": {
                "file": "plik",
                "files": "pliki"
            },
            "fail": {
                "multiple": "{{failCount}} z {{totalCount}} plików {{fileEnding}} nie zostało przesłanych z powodu błędu.",
                "single": "{{failCount}} z {{totalCount}} {{fileEnding}} nie zostało przesłane z powodu błędu."
            },
            "success": {
                "multiple": "Wszystkie pliki zostały pomyślnie dodane do wybranych firm.",
                "single": "Wszystkie pliki zostały pomyślnie dodane do wybranej firmy."
            }
        },
        "filtered": "Filtrowane",
        "filtered companies": "Filtrowane firmy",
        "filtered devices": "Filtrowane urządzenia",
        "filtered files": "Filtrowane pliki",
        "filtered groups": "Filtrowane grupy",
        "filtered tasks": "Filtrowane zadania",
        "filtered users": "Filtrowani użytkownicy",
        "find tool": {
            "device": {
                "error not valid": "Numer IMEI musi składać się z 15 znaków",
                "error subtitle": "Nie znaleziono urządzenia. Spróbuj wpisać inny numer IMEI.",
                "error title": "Nie znaleziono żadnego urządzenia",
                "link": "Przejdź do urządzenia",
                "no permission": "Nie masz uprawnień do wyświetlania tego urządzenia."
            },
            "user": {
                "error not valid": "Nieprawidłowy format adresu e-mail",
                "error subtitle": "Nie znaleziono użytkownika. Spróbuj wpisać inny adres e-mail użytkownika.",
                "error title": "Nie znaleziono użytkownika",
                "link": "Przejdź do użytkownika",
                "no permission": "Nie masz uprawnień do wyświetlania tego użytkownika."
            }
        },
        "firmware date": "Data firmware",
        "from form": "Z formularza",
        "from file": "Z pliku",
        "general": "Ogólne",
        "gsm_number": "Numer GSM",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "Ograniczenie IMEI",
        "import device data": "Importuj dane urządzeń",
        "import device data description": "Importuj wybrane dane atrybutów dla urządzeń z podanej listy.",
        "import device data info": "Każdy atrybut ma maksymalną liczbę znaków wyświetlaną w nawiasach. Jeśli atrybut ma więcej znaków niż maksymalny limit, zostanie automatycznie skrócony do maksymalnego limitu.",
        "import device data limit": "(maksymalnie {{limit}} znaków)",
        "imsi": "IMSI",
        "input text too long": "Tekst jest zbyt długi. Maksymalna dopuszczalna długość to {{maxLength}} znaków.",
        "invalid hardware key": "Nieprawidłowy format klucza sprzętowego",
        "invalid imei": "Numer IMEI jest nieprawidłowy",
        "invalid ipv4": "Nieprawidłowy format IPv4",
        "invalid serial": "Nieprawidłowy numer seryjny",
        "invalid value": "Nieprawidłowa wartość",
        "inverted selection": "Odwrócony wybór",
        "invite user": "Zaproś użytkownika",
        "invite user description": "Zaproś nowego użytkownika do wybranej firmy macierzystej i ustaw jego rolę. Po wysłaniu zaproszenia użytkownik będzie miał 30 dni na jego przyjęcie, zanim wygaśnie.",
        "invite user max roles": "Dozwolonych jest maksymalnie 5 ról. Aby kontynuować, należy odznaczyć jedną z nich.",
        "log files": "Pliki dziennika",
        "make": "Make",
        "manage permissions": "Zarządzaj wszystkimi danymi na poziomie konta i witryny.",
        "maximum value is": "Maksymalna wartość wynosi {{value}}",
        "merge companies": "Połączenie firm",
        "merge companies info": "Wszystkie zasoby firmy źródłowej (urządzenia, grupy, pliki, firmy, użytkownicy wraz z ich rolami) zostaną przeniesione do firmy docelowej. Przed połączeniem warto sprawdzić role użytkowników. Firma źródłowa zostanie następnie usunięta.",
        "merge companies disabled option": {
            "client to internal": "Firma typu klient nie może zostać połączona z firmą wewnętrzną.",
            "internal": "Firmy typu wewnętrznego nie można połączyć.",
            "lz code": "Firma z kodem nie może zostać połączona."
        },
        "minimum value is": "Minimalna wartość to {{value}}",
        "move companies disabled option": {
            "internal": "Firma typu wewnętrznego nie może zostać przeniesiona."
        },
        "move device": "Przenieś urządzenie",
        "move device description": "Przenieś wybrane lub przefiltrowane urządzenia do istniejącej firmy i/lub grupy w hierarchii firmy.",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "Przenoszenie urządzeń",
        "name": "Nazwa",
        "newest": "Od najnowszych",
        "no dropdown files": {
            "description": "Aby wybrać tę opcję, prześlij nowy plik $t(Dialog##no dropdown files##file names##{{fileName}}).",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "Lista autoryzacji 1-Wire",
                "adas_firmware": "Firmware ADAS",
                "ble_fw": "Firmware BLE",
                "blue_nrg": "Firmware BlueNrg",
                "bluetooth_authorization_list": "Lista autoryzacji Bluetooth",
                "can_chip_firmware": "Firmware FM CAN Chip",
                "carrier_advance_firmware": "Firmware Carrier Advance",
                "carrier_advance_settings": "Ustawienia Carrier Advance",
                "carrier_apx_firmware": "Firmware Carrier APX",
                "carrier_apx_settings": "Ustawienia Carrier APX",
                "certificate": "Certyfikat TLS",
                "configuration": "konfiguracja",
                "dsm_firmware": "Firmware DSM",
                "dtb": "DTB",
                "firmware": "Firmware",
                "fw_bundle": "Pakiet firmware",
                "gnssm_download_assistant": "Asystent pobierania GNSS-M",
                "gnssm_firmware": "Firmware GNSS-M",
                "main configuration": "",
                "manual_geofence_list": "Ręczna lista scenariuszy geofence",
                "meig_modem_firmware": "Firmware modemu MeiG",
                "netprisma_modem_firmware": "Firmware modemu NETPRISMA",
                "psub": "subskrypcja",
                "quectel_modem_firmware": "Firmware modemu Quectel",
                "simcom_modem_firmware": ""
            },
            "main": "Nie ma żadnych plików $t(Dialog##no dropdown files##file names##{{fileName}})."
        },
        "none": "Brak",
        "obd oem": "OBD OEM",
        "offline license delete description": "Czy na pewno chcesz usunąć licencję offline „{{name}}”?",
        "oldest": "Od najstarszego",
        "only integers": "Dozwolone są tylko liczby całkowite",
        "only numbers": "Dozwolone są tylko liczby",
        "optional": "opcjonalnie",
        "other companies": "Inne firmy",
        "parent company": "Firma macierzysta",
        "permission preset": "Wstępnie ustawione uprawnienia",
        "platform compatibility": {
            "banner text": "Niektóre wybrane modele urządzeń nie są kompatybilne z wybranym typem zadania. Ten typ zadania nie zostanie domyślnie utworzony dla niekompatybilnych modeli urządzeń.",
            "compatible model devices": "Kompatybilne modele urządzeń",
            "count text": "Zadanie zostanie utworzone dla <1>{{compatibleCount}}</1> spośród {{totalCount}} urządzeń.",
            "create tasks for incompatible devices": "Tworzenie zadań dla niekompatybilnych urządzeń.",
            "devices from file": "Urządzenia z pliku",
            "platform": "Platforma {{title}}",
            "task applies": "Zadanie dotyczy",
            "task cannot be created": "Nie można utworzyć zadania dla niekompatybilnych modeli urządzeń."
        },
        "receiving company": "Ta firma otrzyma Twoje urządzenia",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "Wykonanie tej czynności może potrwać kilka minut.",
            "banner description": "Aby zobaczyć zaktualizowany status zadań, zapoznaj się ze szczegółami grupy zadań lub odśwież stronę.",
            "description": "Naciśnięcie przycisku „Akceptuj” spowoduje ponowne wykonanie wszystkich nieudanych zadań. Czy na pewno chcesz kontynuować?",
            "title": "Powtórzyć wszystkie zadania w grupie?"
        },
        "revision": "Wersja",
        "revision value error": "Wartość musi składać się z dwóch cyfr (00–99).",
        "role name": "Nazwa roli",
        "root company": "Firma macierzysta",
        "sales email": "E-mail kierownika ds. sprzedaży",
        "scheduled time warning": "Zadania z zaplanowanym czasem nie zmieniają konfiguracji czasu połączenia FOTA urządzenia. Zadania zostaną wykonane, jeśli urządzenie połączy się z FOTA w wybranym przedziale czasowym. Należy upewnić się, że urządzenia są skonfigurowane tak, aby łączyły się z FOTA WEB w okresie nie krótszym niż wybrany przedział czasowy.",
        "schedule task": "Planowanie zadań",
        "select": "Wybierz",
        "select at least one": {
            "companies": "Proszę wybrać co najmniej jedną firmę",
            "devices": "Wybierz co najmniej jedno urządzenie",
            "files": "Proszę wybrać co najmniej jeden plik",
            "groups": "Wybierz co najmniej jedną grupę",
            "tasks": "Wybierz co najmniej jedno zadanie",
            "users": "Wybierz co najmniej jednego użytkownika"
        },
        "selected": "Wybrane",
        "selected companies": "Wybrane firmy",
        "selected deviceModels": "Wybrane modele",
        "selected devices": "Wybrane urządzenia",
        "selected files": "Wybrane pliki",
        "selected groups": "Wybrane grupy urządzeń",
        "selected productCodes": "Wybrane kody produktów",
        "selected roles": "Wybrane role",
        "selected tasks": "Wybrane zadania",
        "selected users": "Wybrani użytkownicy",
        "select company": "",
        "select group": "",
        "select time interval": "Wybierz przedział czasowy",
        "selected time window": "Wybrane okno czasowe: {{fromDate}} do {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "Wybierz dostępne pliki dla urządzeń platformy {{platformName}}.",
            "title": "Pliki platformy {{platformName}}"
        },
        "sn": "Numer seryjny.",
        "specific": "Szczegółowe informacje",
        "time period": "Okres czasu",
        "time period custom": "Niestandardowy",
        "tls certificate transfer info": "",
        "token has expired": "Token wygasł",
        "token is valid": "Token jest ważny",
        "transfer companies": "Transferuj firmy",
        "transfer companies description": "Wybierz, czy chcesz przenieść, czy połączyć dwie firmy. Niektóre opcje są nieodwracalne.",
        "transfer devices": "Transferuj urządzenia",
        "tri source": {
            "selected tab description": {
                "create task": "Wybrane zadanie zostanie utworzone dla wybranych urządzeń za pomocą pola wyboru.",
                "general": "Wybrana czynność zostanie wykonana dla wybranych urządzeń zaznaczonych w polu wyboru."
            },
            "filtered tab description": {
                "create task": "Wybrane zadanie zostanie utworzone dla przefiltrowanych urządzeń przy użyciu jednego lub kilku dostępnych filtrów.",
                "general": "Wybrana akcja zostanie wykonana dla urządzeń przefiltrowanych przy użyciu jednego lub kilku dostępnych filtrów."
            },
            "from file tab description": {
                "create task": "Wybrane zadanie zostanie utworzone dla urządzeń określonych w przesłanym pliku.",
                "general": "Wybrana czynność zostanie wykonana dla urządzeń określonych w przesłanym pliku."
            }
        },
        "unlocker": {
            "generate unlock key": "Generowanie klucza odblokowującego",
            "generate unlock key description": "Wpisz „Kod blokady” urządzenia z TCT w polu poniżej. Naciśnij przycisk „Generuj”, aby wygenerować klucz odblokowujący, a następnie użyj go w TCT, aby odblokować urządzenie.",
            "invalid lock code": "Nieprawidłowy kod blokady urządzenia.",
            "limit reached": "Osiągnąłeś maksymalną liczbę wygenerowanych kluczy odblokowujących.",
            "lock code": "Kod blokady",
            "unlock key": "Klucz odblokowujący",
            "unlock key success message": "Klucz odblokowujący został pomyślnie wygenerowany."
        },
        "upload file": "Przesyłanie plików",
        "upload file description": "Prześlij do {{count}} plików jednocześnie, korzystając z pola przeciągnij i upuść lub wybierając je.",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "Wersje firmware 04.00.00 i nowsze zawierają zabezpieczenie przed downgradem. Więcej informacji na temat zmian w oprogramowaniu sprzętowym można znaleźć w naszej dokumentacji pod adresem <1>Teltonika GPS Wiki</1>. Naciskając przycisk „Dalej”, wyrażasz zgodę i potwierdzasz zrozumienie powyższych informacji.",
        "upload firmware unsupported info": "Aktualizacja do tej wersji nie jest dostępna. Skontaktuj się z pomocą techniczną Teltonika lub kierownikiem sprzedaży Teltonika.",
        "use at least one filter": "Proszę użyć co najmniej jednego filtra",
        "user": "Użytkownik",
        "valid until": "Ważny do",
        "valid until date disable description": "To pole można zmienić tylko wtedy, gdy okres czasu jest ustawiony na „Niestandardowy”",
        "vehicle model": "Model"
    },
    "Dropzone": {
        "add file": "Dodaj plik",
        "add files": "Dodaj pliki",
        "drop file to upload": "Przeciągnij plik, aby go przesłać",
        "drop files to upload": "Przeciągnij pliki, aby je przesłać",
        "error uploading the file": "Wystąpił błąd podczas przesyłania pliku",
        "file invalid type": "Wybrano nieprawidłowy typ pliku.",
        "file successfully uploaded": "Plik został pomyślnie przesłany",
        "file syntax": "Składnia pliku jest następująca:",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "Osiągnięto maksymalny limit plików.",
        "only one file can be attached": "Można załączyć tylko jeden plik.",
        "or drop file to upload": "Lub przeciągnij plik, aby go przesłać",
        "or drop files to upload": "Lub przeciągnij pliki, aby je przesłać",
        "rows detected": "Wiersze w pliku zostały pomyślnie wykryte",
        "select file": "Wybierz plik",
        "select files": "Wybierz pliki",
        "select file type": "Najpierw wybierz typ pliku.",
        "supported formats": "Obsługiwane formaty",
        "too long file name": "Nazwa pliku jest zbyt długa. Maksymalna długość to {{maxLength}} znaków.",
        "too many files description": "Pozostałe pliki można przesłać po przesłaniu wybranych plików.",
        "too many files title": "Istnieje maksymalny limit {{maxFiles}} plików, które można załączyć jednocześnie."
    },
    "Error": {
        "error": "Błąd",
        "message wait": "Prosimy o cierpliwość, dopóki nie naprawimy błędu.",
        "title": "Coś poszło nie tak!"
    },
    "Feature highlight": {
        "got it": "Rozumiem",
        "new feature": "Nowa funkcja!",
        "scenarios description": "Teraz możesz ustawić na swoim urządzeniu jeden z następujących scenariuszy: przekroczenie prędkości, wykrywanie kolizji lub wykrywanie holowania."
    },
    "Filter": {
        "access group": "",
        "activity_status": "Status",
        "all permissions": "Wszystkie uprawnienia",
        "batch_id": "Identyfikator partii",
        "company_id": "Firma",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "Stworzony przez",
        "current_configuration": "Konfiguracja",
        "current_firmware": "Firmware",
        "device_imei": "Numer IMEI urządzenia",
        "file type": "Typ pliku",
        "filtered by": "Filtrowane według",
        "filters used": "Używane filtry",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "Grupa",
        "id": "ID",
        "Invalid company": "Nieprawidłowa firma",
        "model": "Model",
        "model_platform": "Platforma",
        "Multiple companies": "Wiele firm",
        "parent company": "Firma macierzysta",
        "permission": "Uprawnienia",
        "permission status": "Status",
        "role": "Rola",
        "spec_id": "Spec ID",
        "status_id": "Status",
        "supported_task_type": "Typ zadania",
        "table filters": "Filtry tabel",
        "task type": "Typ zadania",
        "task_queue": "Kolejka",
        "type": "Typ",
        "user status": "Status"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "Rozmiar pliku firmware ADAS nie może wynosić zero.",
        "ADAS firmware is invalid.": "Firmware ADAS jest nieprawidłowe.",
        "All notifications were deleted.": "Wszystkie powiadomienia zostały usunięte.",
        "All notifications were marked as read.": "Wszystkie powiadomienia zostały oznaczone jako przeczytane.",
        "At least one user role must be provided.": "Należy zapewnić co najmniej jedną rolę użytkownika.",
        "Attributes length is invalid": "Długość atrybutów jest nieprawidłowa.",
        "Banner was updated.": "",
        "Batch was discarded": "Partia została odrzucona.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "Utworzono zadanie zbiorczej aktualizacji atrybutów. Atrybuty urządzeń zostaną wkrótce zaktualizowane.",
        "Bulk create job was created. Devices will be created shortly.": "Utworzono zadanie zbiorczego tworzenia. Urządzenia zostaną utworzone wkrótce.",
        "Bulk create job was created. Tasks will be created shortly.": "Utworzono zadanie zbiorcze. Zadania zostaną utworzone wkrótce.",
        "Bulk delete job was created. Companies will be removed shortly.": "Utworzono zadanie zbiorczego usuwania. Firmy zostaną wkrótce usunięte.",
        "Bulk delete job was created. Devices will be removed shortly.": "Utworzono zadanie zbiorczego usuwania. Urządzenia zostaną wkrótce usunięte.",
        "Bulk delete job was created. Files will be removed shortly.": "Utworzono zadanie zbiorczego usuwania. Pliki zostaną wkrótce usunięte.",
        "Bulk delete job was created. Groups will be removed shortly.": "Utworzono zadanie zbiorczego usuwania. Grupy zostaną wkrótce usunięte.",
        "Bulk delete job was created. Product codes will be removed shortly.": "Utworzono zadanie zbiorczego usuwania. Kody produktów zostaną wkrótce usunięte.",
        "Bulk delete job was created. Users will be removed shortly.": "Utworzono zadanie zbiorczego usuwania. Użytkownicy zostaną wkrótce usunięci.",
        "Bulk task create job was created. Tasks will be created shortly.": "Zadanie zbiorcze zostało utworzone, a zadania pojawią się wkrótce. Zadania można znaleźć na stronie „Grupy zadań” w sekcji Szczegóły grupy zadań.",
        "Bulk update job was created. Devices will be updated shortly.": "Utworzono zadanie zbiorczej aktualizacji. Urządzenia zostaną wkrótce zaktualizowane.",
        "Bulk update job was created. Tasks will be updated shortly.": "Utworzono zadanie zbiorczej aktualizacji. Zadania zostaną wkrótce zaktualizowane.",
        "Can adapter was added.": "Dodano adapter.",
        "Can adapter was deleted.": "Adapter Can został usunięty.",
        "Can adapter was updated.": "Zaktualizowano adapter.",
        "Can chip firmware file size can't be zero": "Rozmiar pliku firmware CAN chip nie może wynosić zero.",
        "Can chip firmware is invalid.": "Firmware CAN chip jest nieprawidłowy.",
        "Cannot delete company. Company is not empty.": "Nie można usunąć firmy. Firma nie jest pusta.",
        "Cannot delete file. It is used by pending or running tasks.": "Nie można usunąć pliku. Jest on używany do zadań oczekujących lub uruchomionych.",
        "Cannot delete file. It is used by running tasks.": "Nie można usunąć pliku. Jest on używany przez uruchomione zadania.",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "Nie można usunąć kodu produktu przypisanego do urządzeń.",
        "check your email for details": "",
        "Companies count limit exceeded.": "Przekroczono limit liczby firm.",
        "Companies in the request must belong to the selected root.": "Firmy w zapytaniu muszą należeć do wybranego katalogu głównego.",
        "Company merge job was created. It will be merged shortly.": "Zadanie połączenia firm zostało utworzone. Wkrótce nastąpi połączenie.",
        "Company name already exist.": "Nazwa firmy już istnieje.",
        "Company level change is not allowed.": "Zmiana poziomu firmy nie jest dozwolona.",
        "Company level successfully changed": "Poziom firmy został pomyślnie zmieniony.",
        "company level successfully reverted": "Poziom firmy został pomyślnie przywrócony do poziomu przypisanego automatycznie.",
        "Company not allowed to be merged": "Firma nie może zostać połączona.",
        "company resource limits changed": "Limity zasobów firmy zostały pomyślnie zmienione.",
        "Company was created.": "Firma została utworzona.",
        "Company was deleted.": "Firma została usunięta.",
        "Company was updated.": "Firma została zaktualizowana.",
        "compatibilities added": "{{count}} nowych kompatybilności dodanych podczas synchronizacji.",
        "compatibilities synchronized": "Pomyślnie zsynchronizowano brakujące kompatybilności.",
        "Configuration cannot have FOTA functionality disabled": "W konfiguracji nie można wyłączyć funkcji FOTA.",
        "Configuration file cannot contain duplicate parameters": "Plik konfiguracyjny nie może zawierać zduplikowanych parametrów.",
        "Configuration file size can't be zero": "Rozmiar pliku konfiguracyjnego nie może wynosić zero.",
        "Configuration files count limit exceeded.": "Przekroczono limit liczby plików konfiguracyjnych.",
        "Configuration version must be defined": "Należy zdefiniować wersję konfiguracji.",
        "custom resource limits successfully reverted": "Limity zasobów niestandardowych zostały pomyślnie przywrócone do limitów przypisanych automatycznie.",
        "Custom roles feature is not enabled.": "Funkcja niestandardowych ról jest dostępna wyłącznie dla użytkowników posiadających konto Premium na poziomie firmy. Wcześniej utworzone niestandardowe role można usuwać.",
        "desktop license added": "Licencja Desktop „{{name}}” została pomyślnie dodana.",
        "Devices already are in target company": "Urządzenia znajdują się już w docelowej firmie.",
        "Device already exists.": "Urządzenie już istnieje.",
        "Device bulk attribute update file cannot be empty": "Plik zbiorczej aktualizacji atrybutów urządzenia nie może być pusty.",
        "Device bulk attribute update file should be .csv": "Plik zbiorczej aktualizacji atrybutów urządzeń powinien mieć format .csv.",
        "Device export limit reached. You can not export more than 100000 devices": "Osiągnięto limit eksportu urządzeń. Nie można eksportować więcej niż 100 000 urządzeń.",
        "Device import limit reached. You can not import more than 100 devices": "Osiągnięto limit importu urządzeń. Nie można zaimportować więcej niż 100 urządzeń.",
        "Device model and task type compatibility was updated.": "Zaktualizowano kompatybilność modeli urządzeń i typów zadań.",
        "Device model was created.": "Stworzono model urządzenia.",
        "Device model was deleted.": "Model urządzenia został usunięty.",
        "Device model was updated.": "Model urządzenia został zaktualizowany.",
        "Device not found": "Nie znaleziono urządzenia.",
        "Device Transfer job was created. Devices will be transfered shortly.": "Zadanie transferu urządzeń zostało utworzone. Urządzenia zostaną wkrótce przeniesione.",
        "Device was added.": "Dodano urządzenie.",
        "Device was deleted.": "Urządzenie zostało usunięte.",
        "Device was updated.": "Urządzenie zostało zaktualizowane.",
        "Email or password is incorrect.": "Podany adres e-mail lub hasło jest nieprawidłowe.",
        "Failed to create Product code": "Nie udało się utworzyć kodu produktu.",
        "Failed to delete Product code": "Nie udało się usunąć kodu produktu.",
        "Failed to import devices.": "Nie udało się zaimportować urządzeń.",
        "Failed to Read Product code": "Nie udało się odczytać kodu produktu.",
        "Failed to retry failed tasks": "Nie udało się ponownie wykonać nieudanych zadań.",
        "Failed to update Product code": "Nie udało się zaktualizować kodu produktu.",
        "Failed to update task for retry": "Nie udało się ponownie wykonać nieudanego zadania.",
        "Field is not valid": "Pole jest nieprawidłowe.",
        "File description is too long. Max 255 characters allowed.": "Opis pliku jest zbyt długi. Dopuszczalna maksymalna długość to 255 znaków.",
        "File exceeds entries limit of 10000.": "Plik przekracza limit 10 000 wpisów.",
        "File must not contain duplicated IMEIs": "Plik nie może zawierać zduplikowanych numerów IMEI.",
        "File must not contain IMEIs that already exist in database.": "Plik nie może zawierać numerów IMEI, które już istnieją w bazie danych.",
        "File must not contain invalid IMEIs": "Plik nie może zawierać nieprawidłowych numerów IMEI.",
        "File name is too long. Max 255 characters allowed.": "Nazwa pliku jest zbyt długa. Dopuszczalna maksymalna długość to 255 znaków.",
        "File name should not contain illegal characters or symbols": "Nazwa pliku nie może zawierać żadnych znaków specjalnych.",
        "File not found": "Nie znaleziono pliku.",
        "File was deleted.": "Plik został usunięty.",
        "File was successfully uploaded.": "Plik został pomyślnie przesłany.",
        "File was updated.": "Plik został zaktualizowany.",
        "File was uploaded. Devices will be imported shortly.": "Plik został przesłany. Urządzenia zostaną wkrótce zaimportowane.",
        "File will be created shortly. Check files in a second.": "Plik zostanie utworzony wkrótce. Sprawdź pliki za chwilę.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "Rozmiar pliku firmware nie może wynosić zero.",
        "First device in file not found.": "Nie znaleziono pierwszego urządzenia w pliku.",
        "Forbidden": "Zabronione.",
        "Group name already exist.": "Nazwa grupy już istnieje.",
        "Group was added.": "„{{group}}” został pomyślnie utworzony.",
        "Group was created.": "Grupa została utworzona.",
        "Group was deleted.": "Grupa została usunięta.",
        "Group was updated.": "Grupa została zaktualizowana.",
        "Invalid device bulk update attribute": "Nieprawidłowy atrybut zbiorczej aktualizacji urządzenia.",
        "Invalid email address.": "Nieprawidłowy adres e-mail.",
        "Invalid file contents": "Nieprawidłowa zawartość pliku.",
        "Invalid file name": "Nieprawidłowa nazwa pliku.",
        "Invalid invitation token.": "Nieprawidłowy token zaproszenia.",
        "Invalid token": "Nieprawidłowy token.",
        "Invalid token length": "Nieprawidłowa długość tokenu.",
        "Internal Server Error": "Wewnętrzny błąd serwera.",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "Licencja została usunięta.",
        "License was updated.": "Licencja została zaktualizowana.",
        "Maximum companies hierarchy depth exceeded": "Przekroczono maksymalną głębokość hierarchii firm",
        "Maximum device group size exceeded.": "Przekroczono maksymalną wielkość grupy urządzeń.",
        "Method Not Allowed": "Metoda niedozwolona.",
        "Network Error": "Błąd sieci.",
        "No changes made": "Nie wprowadzono żadnych zmian.",
        "No resources found.": "Nie znaleziono żadnych zasobów.",
        "not allowed to affect batch": {
            "description": "Upewnij się, że kontrolujesz firmę użytkownika, który utworzył tę grupę zadań.",
            "title": {
                "approve": "Nie masz uprawnień do zatwierdzenia tej partii.",
                "discard": "Nie masz uprawnień do usunięcia tej partii."
            }
        },
        "Not Found": "Nie znaleziono.",
        "Notification was deleted.": "Powiadomienie zostało usunięte.",
        "notify when done title": "Może to chwilę potrwać. Naciśnij przycisk poniżej, aby zamknąć ten ekran, a po zakończeniu otrzymasz powiadomienie.",
        "Obd record was created.": "Utworzono rekord OBD.",
        "Obd record was updated.": "Zaktualizowano zapis OBD.",
        "offline license added": "Licencja offline „{{name}}” została pomyślnie dodana.",
        "Offline license was deleted.": "Licencja offline została usunięta.",
        "Only id_list source is supported.": "Obsługiwane jest tylko źródło id_list.",
        "Only users with Teltonika email can be invited into internal companies.": "Do wewnętrznych firm mogą być zapraszani wyłącznie użytkownicy posiadający adres e-mail Teltonika.",
        "Only users with Teltonika email can be moved into internal companies.": "Tylko użytkownicy posiadający adres e-mail Teltonika mogą zostać przeniesieni do wewnętrznych firm.",
        "Parent company cannot be a descendant of the updated company.": "Spółka macierzysta nie może być spadkobiercą zaktualizowanej spółki.",
        "Password reset link was sent to Your email.": "Link do resetowania hasła został wysłany na Twój adres e-mail.",
        "Password reset token is invalid, expired or related user no longer exists.": "Token resetowania hasła jest nieprawidłowy, wygasł lub użytkownik już nie istnieje.",
        "Password was changed.": "Hasło zostało zmienione.",
        "product code added": "Kod produktu „{{code}}” został pomyślnie dodany.",
        "Product code is too long. Max 200 characters allowed.": "Kod produktu jest zbyt długi. Dopuszczalna maksymalna długość to 200 znaków.",
        "ProductCode already exists.": "Kod produktu już istnieje.",
        "ProductCode not found": "Nie znaleziono kodu produktu.",
        "Product code was deleted.": "Kod produktu został usunięty.",
        "Product code was updated.": "Kod produktu został zaktualizowany.",
        "Retry failed tasks job was created": "Utworzono zadanie ponownej próby wykonania nieudanych zadań.",
        "Role cannot be set for an internal user.": "Nie można ustawić roli dla użytkownika wewnętrznego.",
        "Role was created.": "Rola została utworzona.",
        "Role was deleted.": "Rola została usunięta.",
        "Role was updated.": "Rola została zaktualizowana.",
        "selected company changed": "Wybrana firma została zmieniona.",
        "Selected firmware bundle is not supported by the device.": "Wybrany pakiet firmware nie jest obsługiwany przez urządzenie.",
        "Server Error": "Błąd serwera.",
        "signalr connection failed": "",
        "signalr join groups failed": "",
        "SMS was sent.": "Wysłano SMS-a.",
        "Something went wrong while saving a new password.": "Wystąpił błąd podczas zapisywania nowego hasła.",
        "Successfully logged out.": "Wylogowanie zakończone sukcesem.",
        "System Admin user level is required in order to perform this action.": "Aby wykonać tę czynność, wymagany jest poziom użytkownika administratora systemu.",
        "Target company cannot be a descendant of source company.": "Firma docelowa nie może być pochodną firmy źródłowej.",
        "Task create limit exceeded.": "Nie można utworzyć grupy zadań dla więcej niż 100 000 urządzeń.",
        "Task type is not retriable": "Typ zadania nie może być ponownie wykonany",
        "Task was added.": "Dodano zadanie.",
        "task was created": "Zadanie zostało utworzone dla {{imei}} („{{taskType}}”). Zadanie można znaleźć na stronie „Urządzenia” w sekcji „Zadania” szczegółów urządzenia.",
        "Task was updated.": "Zadanie zostało zaktualizowane.",
        "Tasks were approved": "Zadania zostały zatwierdzone.",
        "The given data was invalid.": "Podane dane były nieprawidłowe.",
        "time zone changed": "Zmieniono strefę czasową.",
        "Token cannot be null or empty": "Token nie może być pusty ani zawierać wartości null.",
        "token created": "Token API został pomyślnie utworzony.",
        "Token has expired": "Token wygasł.",
        "Token's and token's owner companies do not match": "Tokeny i firmy będące właścicielami tokenów nie są ze sobą zgodne.",
        "Token was deleted.": "Token został usunięty.",
        "Too many resources in the request": "Zbyt wiele zasobów w żądaniu",
        "Too Many Requests": "Zbyt wiele żądań.",
        "Transfer token created": "Utworzono token transferu.",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "Dwuskładnikowe uwierzytelnianie jest już aktywowane dla użytkownika.",
        "Two factor authentication successfully disabled.": "Udało się wyłączyć uwierzytelnianie dwuskładnikowe.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "Nie można wysłać wiadomości SMS. To urządzenie nie ma przypisanego numeru GSM.",
        "Unable to validate Your request.": "Nie można zweryfikować Twojego żądania.",
        "Unauthenticated.": "Nieautoryzowany.",
        "Unauthorized": "Nieautoryzowany.",
        "User access level is not valid": "Poziom dostępu użytkownika jest nieprawidłowy",
        "User invitation was revoked": "Zaproszenie zostało pomyślnie anulowane.",
        "User invitation was re-sent": "Zaproszenie dla użytkownika zostało ponownie wysłane.",
        "User is already in the system.": "Użytkownik jest już w systemie.",
        "User was created.": "Użytkownik został utworzony.",
        "User was deleted.": "Użytkownik został usunięty.",
        "User was invited.": "Zaproszenie użytkownika zostało pomyślnie wysłane.",
        "User was updated": "Użytkownik został zaktualizowany.",
        "Users count limit exceeded.": "Przekroczono limit liczby użytkowników.",
        "Your password has been changed.": "Twoje hasło zostało zmienione."
    },
    "General": {
        "0": "Użytkownik",
        "5": "Wsparcie",
        "10": "Administrator",
        "15": "Menedżer administracyjny",
        "19": "",
        "20": "Użytkownik systemu",
        "99": "Superużytkownik",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "Tworzenie firmy",
        "Company.Delete": "Usunięcie firmy",
        "Company.Merge": "Fuzja firm",
        "Company.Update": "Aktualizacja firmy",
        "Device.Export": "Eksport urządzeń",
        "Device.Read": "Odczyt urządzeń",
        "Device.SecretsRead": "",
        "Device.Transfer": "Transfer urządzeń",
        "Device.Unlock": "Odblokowanie urządzenia",
        "Device.Update": "Aktualizacja urządzeń",
        "DeviceGroup.Create": "Tworzenie grup urządzeń",
        "DeviceGroup.Delete": "Usuwanie grup urządzeń",
        "DeviceGroup.Read": "Odczyt grupy urządzeń",
        "DeviceGroup.Update": "Aktualizacja grupy urządzeń",
        "File.Create": "Tworzenie plików",
        "File.Delete": "Usuwanie plików",
        "File.Download": "Pobieranie plików",
        "File.Read": "Odczyt plików",
        "File.TctWebAccess": "TCT web",
        "File.Update": "Aktualizacja plików",
        "Role.Create": "Tworzenie ról",
        "Role.Delete": "Usunięcie roli",
        "Role.Read": "Rola czytania",
        "Role.Update": "Aktualizacja roli",
        "Task.Create": "Tworzenie zadań",
        "Task.Read": "Odczyt zadań",
        "Task.Retry": "Ponowne próby wykonania zadania",
        "Task.Update": "Aktualizacja zadań",
        "TaskGroup.Read": "Odczyt grupy zadań",
        "TctIntegration.Access": "Integracja TCT",
        "Token.Create": "Tworzenie tokenów",
        "Token.Delete": "Usuwanie tokenów",
        "Token.Read": "Odczyt tokenu",
        "User.Create": "",
        "User.Delete": "Usuwanie użytkowników",
        "User.Read": "Czytanie przez użytkownika",
        "User.Update": "Aktualizacja użytkownika",
        "--- END-OF-PERMISSIONS ---": "",
        "1_wire_authorization": "",
        "1-wire authorization list": "Lista autoryzacji 1-Wire",
        "1_wire_authorization_list": "Lista autoryzacji 1-Wire",
        "Active": "Aktywny",
        "adas_firmware": "Firmware ADAS",
        "apx_firmware": "Firmware APX",
        "assign can package": "Przypisz pakiet CAN",
        "assigned package": "Przypisany pakiet",
        "automatic": "Automatyczny",
        "banner management": "",
        "batches": "Grupy zadań",
        "black_box": "Czarna skrzynka",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Firmware BLE",
        "blue_nrg": "Firmware BlueNRG",
        "bluetooth_authorization": "",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "Lista autoryzacji Bluetooth",
        "bluetooth_authorization_list": "Lista autoryzacji Bluetooth",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "Niezgodny",
                "true": "Kompatybilny"
            },
            "web_editor_support": {
                "false": "TCT web nieobsługiwane",
                "true": "Obsługiwany przez TCT web"
            }
        },
        "can": "CAN",
        "can adapter name": "Nazwa adaptera CAN",
        "can bootstring": "Bootstring",
        "can configuration": "Konfiguracja OEM",
        "can_debug_log": "Dziennik debugowania CAN",
        "can oem file package": "Pakiet plików OEM",
        "can oem file vehicle": "Plik OEM pojazdu",
        "can package": "Pakiet OEM",
        "can program number": "Numer programu CAN",
        "can revision": "Wersja CAN",
        "can software date": "Data oprogramowania CAN",
        "can type": "Typ CAN",
        "Cancelled": "Anulowano",
        "cancel task": "Anuluj zadanie",
        "can_chip_firmware": "Firmware FM CAN Chip",
        "carrier_advance_firmware": "Firmware Carrier Advance",
        "carrier_advance_settings": "Ustawienia Carrier Advance",
        "carrier_apx_firmware": "Firmware Carrier APX",
        "carrier_apx_settings": "Ustawienia Carrier APX",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "Pliki rejestratora temperatury Carrier",
        "certificate": "Certyfikat",
        "click for more details": "Kliknij, aby uzyskać więcej informacji",
        "client ip": "Adres IP klienta",
        "clone model": "Klonowanie modelu urządzenia",
        "collapse menu": "Zwiń menu",
        "companies": "Firmy",
        "company": "Firma",
        "company level": "Poziom firmy",
        "company type": "Rodzaj firmy",
        "company name": "Nazwa firmy",
        "Completed": "Ukończone",
        "Completed with errors": "Ukończono z błędami",
        "configuration": "Konfiguracja",
        "configuration_36": "Konfiguracja (FM36)",
        "configuration_64": "Konfiguracja (FMB64)",
        "crash_dump": "Dziennik zrzutu pamięci po awarii",
        "created at": "Utworzony w",
        "created by": "Stworzony przez",
        "custom": "Niestandardowy",
        "custom resource limits": "Indywidualne limity zasobów",
        "dashboard": "Pulpit nawigacyjny",
        "delete desktop license": "Usuń licencję na desktop",
        "delete offline license": "Usuń licencję offline",
        "desktopLicenses": "Licencje na komputery desktopowe",
        "device_export_file_csv": "Plik eksportu urządzeń (.csv)",
        "device_export_file_xlsx": "Plik eksportu urządzeń (.xlsx)",
        "deviceModels": "Modele",
        "deviceModelTaskCompatibilities": "Kompatybilność",
        "device_transfer_report": "Raport transferu urządzeń",
        "device group": "Grupa",
        "DeviceImportFile": "Plik importu urządzeń",
        "devices": "Urządzenia",
        "download file": "Pobierz plik",
        "download offline license": "Pobierz licencję offline",
        "dsm_firmware": "Firmware DSM",
        "dtb": "DTB",
        "edit compatibility": "Edytuj kompatybilność urządzeń",
        "edit model": "Edytuj model urządzenia",
        "edit company": "Edytuj firmę",
        "edit desktop license": "Edytuj licencję na desktop",
        "edit device": "Edytuj urządzenie",
        "edit file": "Edytuj plik",
        "edit group": "Edytuj grupę",
        "edit in tct web": "Edytuj w TCT web",
        "edit in tct web disabled": "Edycja w TCT web jest dostępna tylko dla firm na poziomie Premium.",
        "edit product code": "Edytuj kod produktu",
        "edit role": "Edytuj rolę",
        "edit smart group": "Edytuj grupę inteligentną",
        "edit user": "Edytuj użytkownika",
        "Empty": "Puste",
        "enter here": "Wejdź tutaj",
        "exception_info": "Informacje o wyjątkach",
        "Executing": "Wykonanie",
        "expand menu": "Rozwiń menu",
        "Expired": "Wygasły",
        "Factory": "",
        "Failed": "Nie powiodło się",
        "file": "Plik",
        "file data": "Dane plików",
        "files": "Pliki",
        "file deleted": "Plik został usunięty",
        "firmware": "Firmware",
        "firmware_36": "Firmware (FM36)",
        "firmware_64": "Firmware (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "Pakiet firmware",
        "fw_bundle_ble": "Pakiet – firmware BLE",
        "fw_bundle_ble_dtb": "Pakiet – BLE DTB",
        "fw_bundle_can": "Pakiet – firmware CAN",
        "fw_bundle_can_dtb": "Pakiet – CAN DTB",
        "fw_bundle_dtb": "Pakiet – Główny DTB",
        "fw_bundle_mainfw": "Pakiet – główne firmware",
        "generic": "",
        "global_configuration": "Konfiguracja globalna",
        "global_firmware": "Globalny firmware",
        "gnssm_download_assistant": "Asystent pobierania GNSS-M",
        "gnssm_firmware": "Firmware GNSS-M",
        "group": "Grupa",
        "groups": "Grupy urządzeń",
        "hardware key": "Klucz sprzętowy",
        "id": "ID",
        "id_collection_file": "Plik zbiór danych identyfikacyjnych",
        "imei restriction": "Ograniczenie IMEI",
        "Inactive": "Nieaktywny",
        "Invalid": "Nieprawidłowy",
        "invalid model": "Nieprawidłowy model",
        "invalid model_name": "Nieprawidłowy model",
        "InvitationExpired": "Wygasłe zaproszenie",
        "InvitationPending": "Oczekujące zaproszenie",
        "Legacy": "Legacy",
        "legacy model": "Model starszej generacji",
        "legacy model_platform": "Starsza platforma",
        "legacy platform": "Starsza platforma",
        "license has expired": "Licencja wygasła",
        "loading": "Ładowanie",
        "log": "Log",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "Ręczny",
        "ManualGeofenceList": "",
        "manual geofence list": "Ręczna lista scenariuszy geofence",
        "manual_geofence_list": "Ręczna lista scenariuszy geofence",
        "manual_geofence_scenarios": "",
        "meig_modem_firmware": "Firmware modemu MeiG",
        "menu": "Menu",
        "modem version": "Wersja modemu",
        "netprisma_modem_firmware": "Firmware modemu NETPRISMA",
        "nmea_log": "Dziennik NMEA",
        "no": "Nie",
        "no results": "Nie znaleziono żadnych wstępnych wyników",
        "no results description": "Gdy tylko {{name}} zostaną przesłane do FOTA WEB, będziesz mógł zobaczyć dane tutaj",
        "not assigned": "Nieprzypisane",
        "not assigned configuration_file_id": "Konfiguracja nieprzypisana",
        "not assigned current_configuration": "Konfiguracja nieprzypisana",
        "not assigned current_firmware": "Brak przypisanego firmware",
        "not assigned firmware_file_id": "Brak przypisanego firmware",
        "not assigned group_id": "Grupa nieprzypisana",
        "not assigned model": "Model nieprzypisany",
        "not assigned spec_id": "Nieprzypisany Spec ID",
        "not assigned task_type": "Typ zadania nieprzypisany",
        "obd_chip_firmware": "Firmware FM OBD Chip",
        "obd chip firmware version": "Wersja firmware OBD chip",
        "Offline": "Offline",
        "offline licenses": "Licencje offline",
        "Online": "Online",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "lub",
        "other": "Inne",
        "Pending": "W toku",
        "Pending approval": "Oczekiwanie na zatwierdzenie",
        "permission disabled": "Wyłączone",
        "permission enabled": "Włączony",
        "productCodes": "Kody produktów",
        "psub": "Plik subskrypcji",
        "quectel_fw": "Firmware modemu Quectel (quectel_fw)",
        "quectel_modem_firmware": "Firmware modemu Quectel",
        "resend invite": "Wyślij ponownie zaproszenie",
        "restricted": "Ograniczony dostęp",
        "retry": "Ponów próbę",
        "roles": "Role i uprawnienia",
        "Running": "Działa",
        "RxAutoscan": "Otrzymuj automatycznie skanowane pliki CAN",
        "RxBlackBox": "Otrzymuj czarną skrzynkę",
        "RxBluetoothAuthorizationList": "Otrzymuj listę autoryzacji Bluetooth",
        "RxCanDebugLog": "Otrzymuj logi debugowania CAN",
        "RxCarrierExtractions": "Pobieranie Carrier extractions",
        "RxCarrierLoggerFiles": "Pobieranie plików rejestratora temperatury Carrier",
        "RxConfiguration": "Otrzymaj konfigurację",
        "RxCrashDump": "Otrzymuj logi zrzutu pamięci po awarii",
        "RxExceptionInfo": "Otrzymuj informacje o wyjątkach",
        "RxLog": "Otrzymuj wewnętrzny dziennik",
        "RxManualGeofenceList": "Otrzymuj ręcznie tworzoną listę scenariuszy geofence",
        "RxNmeaLog": "Otrzymuj logi NMEA",
        "RxOneWireAuthorizationList": "Otrzymuj listę autoryzacji 1-Wire",
        "RxWdLog": "Otrzymuj logi watch-dog (WD)",
        "select company": "Wybierz firmę",
        "SetBindSim": "Powiązanie urządzenia z aktualną kartą SIM (kartami SIM)",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "Wyłącz funkcję",
        "SetEnableFeature": "Włącz funkcję",
        "SetForceLockSim": "Wymuszone blokowanie karty SIM",
        "SetUnbindSim": "Odłączenie urządzenia od karty SIM (kart SIM)",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "Status",
        "task details": "Szczegóły zadania",
        "task groups": "Grupy zadań",
        "tasks": "Grupy zadań",
        "tasksCompatibility": "Kompatybilność zadań",
        "task type": "Typ zadania",
        "Tct": "",
        "time zone": "Strefa czasowa",
        "total": "Całkowity",
        "tutorials": "Samouczki",
        "TxAdasFirmware": "Przesyłanie firmware ADAS",
        "TxAgpsMt3333": "Przesyłanie pliku AGPSM",
        "TxAgpsQuectelL89": "Przesyłanie pliku AGPSQ",
        "TxAutoscanCanConfiguration": "Przesyłanie plików OEM z autoscan",
        "TxBleFirmware": "Przesyłanie firmware BLE",
        "TxBlueNrgFirmware": "Przesyłanie BlueNrg firmware",
        "TxBluetoothAuthorizationList": "Przesyłanie listy autoryzacji Bluetooth",
        "TxBundleBle": "Przesyłanie firmware BLE",
        "TxBundleBleDtb": "Przesyłanie BLE DTB",
        "TxBundleCan": "Przesyłanie firmware CAN",
        "TxBundleCanDtb": "Przesyłanie CAN DTB",
        "TxBundleDtb": "Przesyłanie głównego DTB",
        "TxBundleFirmware": "Przesyłanie głównego firmware",
        "TxCanAdapterModeChange": "Zmiana trybu zewnętrznego adaptera CAN",
        "TxCanAdapterModeChangeInternal": "Zmiana trybu wewnętrznego adaptera CAN",
        "TxCanAdapterUpdate": "Przesyłanie firmware adaptera CAN",
        "TxCanAdapterUpdateInternal": "Aktualizacja wewnętrznego adaptera CAN",
        "TxCanChipFirmware": "Przesyłanie firmware FMXY50 CAN chip",
        "TxCanConfiguration": "Przesyłanie plików OEM",
        "TxCarrierAdvanceFirmware": "Aktualizacja firmware Carrier Advance",
        "TxCarrierAdvanceSettings": "Aktualizacja ustawień Carrier Advance",
        "TxCarrierApxFirmware": "Aktualizacja firmware Carrier APX",
        "TxCarrierApxSettings": "Aktualizacja ustawień Carrier APX",
        "TxConfiguration": "Konfiguracja przesyłania",
        "TxDsmFirmware": "Przesyłanie oprogramowania DSM",
        "TxDtb": "Przesyłanie DTB",
        "TxFirmware": "Przesyłanie firmware",
        "TxFirmwareBundle": "Przesyłanie kontenera pakietu firmware",
        "TxFirmwareBundleParts": "Przesyłanie pakietu firmware",
        "TxFotaCertificate": "Aktualizacja certyfikatu FOTA",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "Asystent pobierania plików GNSS-M",
        "TxGNSSMFirmware": "Przesyłanie firmware GNSS-M",
        "TxManualGeofenceList": "Przesyłanie ręcznej listy scenariuszy geofence",
        "TxMeigModemDeltaFirmware": "Przesyłanie firmware modemu MeiG Delta",
        "TxNetprismaModemDeltaFirmware": "Przesyłanie firmware modemu NETPRISMA Delta",
        "TxObdChipFirmware": "Aktualizacja OBD chip",
        "TxObdConfig": "Przeniesienie pliku konfiguracyjnego OBD",
        "TxOneWireAuthorizationList": "Przesyłanie listy autoryzacji 1-Wire",
        "TxPSub": "Przenieś plik subskrypcji",
        "TxQuectelModemDeltaFirmware": "Przesyłanie firmware modemu Quectel Delta",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "Przesyłanie certyfikatu TLS użytkownika",
        "users": "Użytkownicy",
        "Unknown": "Nieznany",
        "unknown": "Nieznany",
        "unknown model_platform": "Nieznana platforma",
        "unknown origin": "",
        "unknown platform": "Nieznana platforma",
        "unrestricted": "Bez ograniczeń",
        "Verifying": "Weryfikacja",
        "vin": "VIN",
        "vip status": "Status VIP",
        "wd_log": "Dziennik WD",
        "yes": "Tak"
    },
    "Maintenance": {
        "title": "Chwileczkę! Trwa konserwacja."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} nie powiodło się z powodu błędu serwera.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "Nie masz uprawnień do anulowania wszystkich wybranych zadań. Niektóre zadania są powiązane z zasobami różnych firm.",
            "Cancel tasks action failed. No resources found.": "Nie znaleziono zadań pasujących do Twojego wyboru. Sprawdź swój wybór zadań i spróbuj ponownie.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "Firma „{{SourceCompanyName}}” ({{SourceCompanyId}}) połączyła się z „{{TargetCompanyName}}” ({{TargetCompanyId}}).",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "Połączenie firm nie powiodło się. Firmy „{{SourceCompanyId}}” i „{{TargetCompanyId}}” nie mogą zostać połączone z powodu niezgodnych ustawień lub uprawnień.",
            "Create device group tasks action failed. No resources found.": "Nie udało się utworzyć zadań dla grupy Smart Group. Spróbuj ponownie przypisać plik.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{CreatedTaskCount}} zadań utworzonych dla urządzeń o identyfikatorze grupy: {{GroupId}}.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "Nie masz uprawnień do tworzenia zadań dla wszystkich wybranych urządzeń. Niektóre urządzenia należą do różnych firm.",
            "Create tasks action failed. No resources found.": "Żadne urządzenia nie pasują do Twojego wyboru. Sprawdź swój wybór urządzeń i spróbuj ponownie.",
            "Create tasks action failed. No resources processed.": "Nie udało się przetworzyć wybranych urządzeń. Spróbuj ponownie utworzyć grupę zadań.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "Nie masz uprawnień do usunięcia wszystkich wybranych firm. Niektóre firmy nie podlegają Twojemu bezpośredniemu zarządzaniu.",
            "Delete companies action failed. No resources found.": "Żadna firma nie pasuje do Twojego wyboru. Sprawdź swój wybór i spróbuj ponownie.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "Nie masz uprawnień do usunięcia wszystkich wybranych plików. Niektóre pliki są powiązane z zasobami różnych firm.",
            "Delete files action failed. No resources found.": "Nie znaleziono plików pasujących do Twojego wyboru. Sprawdź wybrane pliki i spróbuj ponownie.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "Nie masz uprawnień do usunięcia wszystkich wybranych grup urządzeń. Niektóre grupy urządzeń zawierają zasoby pochodzące z różnych firm.",
            "Delete groups action failed. No resources found.": "Żadna grupa urządzeń nie pasuje do Twojego wyboru. Sprawdź wybór grupy urządzeń i spróbuj ponownie.",
            "Delete product codes action failed. No resources found.": "Żaden kod produktu nie pasuje do Twojego wyboru. Sprawdź wybrane kody produktów i spróbuj ponownie.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "Nie masz uprawnień do usunięcia wszystkich wybranych użytkowników. Niektórzy użytkownicy należą do różnych firm.",
            "Delete users action failed. No resources found.": "Nie znaleziono użytkowników pasujących do Twojego wyboru. Sprawdź swój wybór użytkowników i spróbuj ponownie.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} urządzeń wyeksportowano do pliku „{{Filename}}”.",
            "{{DevicesCount}} device(s) imported.": "Zaimportowano {{DevicesCount}} urządzeń.",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "Przetworzono {{DevicesProcessedCount}} urządzeń, utworzono {{TasksCreatedCount}} zadań.",
            "Export devices action failed. No resources found.": "Żadne urządzenia nie pasują do Twojego wyboru. Sprawdź swój wybór urządzeń i spróbuj ponownie.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "{{FailedTaskCount}} zadań powróciło do stanu oczekującego w grupie zadań {{BatchId}}.",
            "Invalid request scope. Resources must belong to single root.": "Nieprawidłowy zakres żądania. Zasoby muszą należeć do jednego katalogu głównego.",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "Usunięto {{ProcessedCount}} firm.",
            "{{ProcessedCount}} device group(s) deleted.": "Usunięto {{ProcessedCount}} grup urządzeń.",
            "{{ProcessedCount}} device attribute(s) updated.": "Zaktualizowano {{ProcessedCount}} atrybutów urządzenia.",
            "{{ProcessedCount}} device model(s) deleted.": "Usunięto {{ProcessedCount}} modeli urządzeń.",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}} urządzeń zaktualizowanych.",
            "{{ProcessedCount}} file(s) deleted.": "Usunięto {{ProcessedCount}} plików.",
            "{{ProcessedCount}} product code(s) deleted.": "Usunięto {{ProcessedCount}} kodów produktów.",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} zadań anulowanych.",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} zadań zaktualizowanych.",
            "{{ProcessedCount}} user(s) deleted.": "Usunięto {{ProcessedCount}} użytkowników.",
            "Retry tasks action failed. No resources found.": "Nie znaleziono zadań pasujących do Twojego wyboru. Sprawdź swój wybór zadań i spróbuj ponownie.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "Nie masz uprawnień do przeniesienia wszystkich wybranych urządzeń. Niektóre urządzenia należą do innych firm.",
            "Transfer devices action failed. No resources found.": "Żadne urządzenia nie pasują do Twojego wyboru. Sprawdź swój wybór urządzeń i spróbuj ponownie.",
            "Transfer devices action failed. No resources processed.": "Nie udało się przetworzyć wybranych urządzeń. Spróbuj ponownie przesłać urządzenia.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "Przeniesiono {{TransferredDevicesCount}} z {{TotalDevicesToTransfer}} urządzeń.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "Nie masz uprawnień do aktualizacji wszystkich wybranych urządzeń. Niektóre urządzenia należą do różnych firm.",
            "Update devices action failed. No resources found.": "Żadne urządzenia nie pasują do Twojego wyboru. Sprawdź swój wybór urządzeń i spróbuj ponownie.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "Nie masz uprawnień do aktualizowania atrybutów wszystkich wybranych urządzeń. Niektóre urządzenia należą do różnych firm.",
            "Update devices attributes action failed. No resources found.": "Żadne urządzenia nie pasują do Twojego wyboru. Sprawdź swój wybór urządzeń i spróbuj ponownie.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "Nie masz uprawnień do aktualizacji wszystkich wybranych zadań. Niektóre zadania są powiązane z zasobami różnych firm.",
            "Update tasks action failed. No resources found.": "Nie znaleziono zadań pasujących do Twojego wyboru. Sprawdź swój wybór zadań i spróbuj ponownie.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "Brak powiadomień",
        "notifications": "Powiadomienia",
        "notifications will be listed": "Wszystkie nowe powiadomienia będą wyświetlane tutaj",
        "remove notification": "Usuń powiadomienie",
        "see previous notifications": "Zobacz poprzednie powiadomienia",
        "timestamps": {
            "days ago": "{{days}} dni temu",
            "hours ago": "{{hours}} godziny temu",
            "minutes ago": "{{minutes}} min temu",
            "moments ago": "Kilka chwil temu"
        },
        "title": {
            "BackgroundActionFailed": "Akcja nie powiodła się",
            "CompaniesSuccessfullyDeleted": "Firmy zostały pomyślnie usunięte",
            "CompanyBulkDeleteFailed": "Wystąpił błąd podczas usuwania firm",
            "CompanyLevelChanged": "Zmiana poziomu firmy",
            "CompanyLevelDowngradeReminder": "Nadchodzące obniżenie poziomu firmy",
            "CompanyMergeFailed": "Wystąpił błąd podczas łączenia firm",
            "CompanySuccessfullyMerged": "Firmy pomyślnie połączyły się",
            "DeviceAttributesSuccessfullyUpdated": "Atrybuty urządzenia zostały pomyślnie zaktualizowane",
            "DeviceBulkAttributeUpdateFailed": "Wystąpił błąd podczas aktualizacji atrybutów urządzenia",
            "DeviceBulkUpdateFailed": "Wystąpił błąd podczas aktualizacji urządzeń",
            "DeviceExportFailed": "Wystąpił błąd podczas eksportowania urządzeń",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "Grupy urządzeń pomyślnie usunięte",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "Wystąpił błąd podczas tworzenia zadań grupy inteligentnej",
            "DeviceGroupTasksSuccessfullyCreated": "Zadania Smart Group zostały pomyślnie utworzone",
            "DeviceModelBulkDeleteFailed": "Wystąpił błąd podczas usuwania modeli urządzeń",
            "DeviceModelsSuccessfullyDeleted": "Modele urządzeń pomyślnie usunięte",
            "DevicesSuccessfullyTransferred": "Urządzenia pomyślnie przeniesione",
            "DevicesSuccessfullyUpdated": "Urządzenia pomyślnie zaktualizowane",
            "DeviceTransferFailed": "Wystąpił błąd podczas przenoszenia urządzeń",
            "ExportFailed": "Eksport zasobów nie powiódł się",
            "ExportSucceeded": "Urządzenia pomyślnie wyeksportowane",
            "FailedTasksRetryFailed": "Wystąpił błąd podczas ponownej próby wykonania zadań",
            "FailedTasksSuccessfullyRetried": "Zadania pomyślnie powtórzone",
            "FileBulkDeleteFailed": "Wystąpił błąd podczas usuwania plików",
            "FilesSuccessfullyDeleted": "Pliki pomyślnie usunięte",
            "GroupBulkDeleteFailed": "Wystąpił błąd podczas usuwania grup urządzeń",
            "ImportFailed": "Nie udało się zaimportować zasobów",
            "ImportSucceeded": "Urządzenia pomyślnie zaimportowane",
            "ProductCodeBulkDeleteFailed": "Wystąpił błąd podczas usuwania kodów produktów",
            "ProductCodesSuccessfullyDeleted": "Kody produktów zostały pomyślnie usunięte",
            "ResourceUpdateFailed": "Aktualizacja zasobów nie powiodła się",
            "ResourceUpdateSucceeded": "Aktualizacja zasobów zakończona sukcesem",
            "RoleBulkDeleteFailed": "Wystąpił błąd podczas usuwania ról",
            "RolesSuccessfullyDeleted": "Role zostały pomyślnie usunięte",
            "TaskBulkCancelFailed": "Wystąpił błąd podczas anulowania zadań",
            "TaskBulkCreateFailed": "Wystąpił błąd podczas tworzenia grupy zadań",
            "TaskBulkUpdateFailed": "Wystąpił błąd podczas aktualizacji zadań",
            "TaskGroupSuccessfullyCreated": "Grupa zadań została pomyślnie utworzona",
            "TasksPropagationFailed": "Nie powiodło się zadanie propagacji zadań",
            "TasksPropagationSucceeded": "Zadanie propagacji zadań zakończone sukcesem",
            "TasksPropagationWarning": "Zadanie propagacji zadań zakończyło się z ostrzeżeniami",
            "TasksSuccessfullyCanceled": "Zadania pomyślnie anulowane",
            "TasksSuccessfullyUpdated": "Zadania pomyślnie zaktualizowane",
            "UserBulkDeleteFailed": "Wystąpił błąd podczas usuwania użytkowników",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "Użytkownicy pomyślnie usunięci"
        }
    },
    "Permission actions": {
        "Access": "Integracja TCT",
        "Create": "Utwórz",
        "Delete": "Usuń",
        "Download": "Pobierz",
        "Export": "Eksport",
        "Merge": "Scal",
        "Read": "Czytaj",
        "Retry": "Ponów próbę",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "Transfer",
        "Unlock": "Odblokuj",
        "Update": "Aktualizacja"
    },
    "Permission groups": {
        "company": "Firmy",
        "device": "Urządzenia",
        "device group": "Grupy urządzeń",
        "file": "Pliki",
        "role": "Role",
        "task": "Zadania",
        "task group": "Grupy zadań",
        "token": "Tokeny",
        "user": "Użytkownicy"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "Ta opcja jest wyłączona dla użytkowników z poziomem podstawowym firmy.",
                "token list": "Tokeny integracji API są wyłączone dla użytkowników z poziomem podstawowym firmy."
            },
            "custom_role_support": {
                "create role": "Z tej funkcji mogą korzystać wyłącznie użytkownicy posiadający konto Premium na poziomie firmowym.",
                "edit role": "Z tej funkcji mogą korzystać wyłącznie użytkownicy posiadający poziom Premium na poziomie firmy. Wcześniej utworzone role niestandardowe można usunąć.",
                "edit user": "Z tej funkcji mogą korzystać wyłącznie użytkownicy posiadający poziom Premium na poziomie firmy. Wcześniej przypisane role niestandardowe mogą zostać usunięte."
            },
            "task_schedule_support": {
                "table head": "Z tej funkcji mogą korzystać wyłącznie użytkownicy posiadający poziom firmy Standard i Premium. Wcześniej dodane zadania z harmonogramami będą nadal wykonywane."
            }
        },
        "general message": "Z tej funkcji mogą korzystać wyłącznie użytkownicy posiadający poziom firmy Standard i Premium.",
        "resource_limit_settings": {
            "tasks_per_group": "Nie można utworzyć zadań dla więcej niż {{limitCount}} urządzeń jednocześnie."
        }
    },
    "Search": {
        "code": "Kod",
        "description": "Opis",
        "email": "E-mail",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "Model",
        "name": "Nazwa",
        "product code": "Kod produktu",
        "role name": "Nazwa roli",
        "serial": "Numer seryjny.",
        "search by": "Wyszukiwanie według",
        "search company name": "Wyszukaj nazwę firmy"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "Chcesz wyłączyć uwierzytelnianie dwuskładnikowe. Może to spowodować, że Twoje konto FOTA WEB stanie się niebezpieczne. Czy na pewno chcesz kontynuować?",
                    "title": "Czy na pewno?"
                },
                "send email code": {
                    "enter code": "Ze względów bezpieczeństwa wprowadź kod w celu weryfikacji adresu e-mail."
                },
                "send otp code": {
                    "description": "6-cyfrowy kod został wysłany do Twojej aplikacji uwierzytelniającej. Ze względów bezpieczeństwa wprowadź wygenerowany kod w polu poniżej.",
                    "no access": {
                        "authenticator": "Jeśli nie masz już dostępu do aplikacji uwierzytelniającej powiązanej z tym kontem, konieczna jest zmiana hasła, aby wyłączyć uwierzytelnianie dwuskładnikowe.",
                        "email": "Jeśli nie masz już dostępu do adresu e-mail powiązanego z tym kontem, konieczna jest zmiana hasła, aby wyłączyć uwierzytelnianie wieloskładnikowe."
                    }
                },
                "title": "Wyłącz uwierzytelnianie dwuskładnikowe"
            },
            "get email code": {
                "description": "Użyj tego kodu na następnym ekranie, aby zweryfikować swoje konto.",
                "description modal": "Użyj tego kodu, aby zweryfikować swoje konto.",
                "title": "Po naciśnięciu przycisku „Wyślij kod” unikalny kod zostanie wysłany na adres <1>{{email}}</1>."
            },
            "get secret code": {
                "description": "Aby zakończyć ten proces, potrzebna będzie aplikacja mobilna służąca do uwierzytelniania, na przykład jedna z poniższych:"
            },
            "select authentication type": {
                "authentication app description": "Uzyskaj unikalny kod z aplikacji takiej jak Microsoft Authenticator lub Google Authenticator.",
                "description": "Aby zapewnić bezpieczeństwo swojego konta i danych klientów, skorzystaj z jednej z poniższych opcji, aby skonfigurować uwierzytelnianie dwuskładnikowe.",
                "description modal": "Wybierz preferowaną metodę uwierzytelniania.",
                "email": "E-mail",
                "email description": "Za każdym razem, gdy spróbujesz się zalogować, wyślemy jednorazowy kod na Twój adres e-mail.",
                "recommended": "Polecane",
                "title": "Uwierzytelnianie dwuskładnikowe (2FA) jest obowiązkowe dla wszystkich użytkowników FOTA WEB.",
                "title modal": "Wybierz metodę uwierzytelniania"
            },
            "send email code": {
                "description": "Wpisz kod w polu poniżej i naciśnij „Weryfikuj”, aby kontynuować.",
                "enter code": "Wpisz kod, żeby zweryfikować adres e-mail.",
                "title": "Unikalny kod został wysłany na adres <1>{{email}}</1>.",
                "verification code": "Kod weryfikacyjny"
            },
            "send otp code": {
                "click to scan code": "Kliknij tutaj, aby zeskanować kod QR",
                "click to type code": "Kliknij tutaj, aby ręcznie wpisać kod",
                "incorrect code": "Nieprawidłowy kod",
                "scan QR code": "Zeskanuj kod QR do swojej aplikacji",
                "six digit code": "6-cyfrowy kod generowany przez aplikację",
                "title": "Aby zakończyć ten proces, potrzebna będzie aplikacja mobilna do uwierzytelniania, taka jak: <1>Microsoft Authenticator</1> lub <2>Google Authenticator</2>.",
                "type text code": "Wpisz kod w swojej aplikacji"
            },
            "settings": {
                "description": "Uwierzytelnianie dwuskładnikowe to dodatkowa warstwa zabezpieczeń, która weryfikuje tożsamość użytkownika za pomocą czegoś, co zna (hasło) i czegoś, co posiada (telefon, klucz bezpieczeństwa, adres e-mail).",
                "disabled": "Wyłączone",
                "enabled": "Włączone",
                "title": "Uwierzytelnianie dwuskładnikowe"
            },
            "success message": {
                "alert": "Pomyślnie włączono uwierzytelnianie dwuskładnikowe.",
                "description": "Za każdym razem, gdy logujesz się przy użyciu adresu e-mail i hasła, poprosimy Cię o podanie kodu uwierzytelniającego.",
                "title": "Pomyślnie włączyłeś uwierzytelnianie dwuskładnikowe.",
                "title modal": "Włączono uwierzytelnianie dwuskładnikowe!"
            },
            "title": {
                "authentication app": "Aplikacja uwierzytelniająca",
                "authentication email": "E-mail uwierzytelniający",
                "is enabled": "Włączone uwierzytelnianie dwuskładnikowe.",
                "protect your account": "Chroń swoje konto FOTA WEB"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "Zmień hasło",
            "enter current password": "Wprowadź aktualne hasło",
            "enter new password": "Wprowadź nowe hasło",
            "hide password": "Ukryj hasło",
            "repeat new password": "Powtórz nowe hasło",
            "rules": {
                "lowercase letter": "Co najmniej jedna mała litera (a-z)",
                "minimum characters": "Co najmniej 12 znaków",
                "new and current passwords must not match": "Nowe i aktualne hasła nie mogą być identyczne",
                "new passwords must match": "Nowe hasła muszą być identyczne",
                "number": "Co najmniej jeden numer",
                "passwords must match": "Hasła muszą być zgodne",
                "special symbol": "Co najmniej jeden specjalny symbol (!@#$%^&*()-_=+)",
                "uppercase letter": "Co najmniej jedna wielka litera (A-Z)"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "Pokaż hasło"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "Statystyki tabel",
        "statistics message": "Filtry tabeli mają wpływ na statystyki widoczne poniżej",
        "activity": "Aktywność",
        "model": "Model",
        "firmware": "Firmware",
        "configuration": "Konfiguracja",
        "statistics": "Statystyki"
    },
    "Table": {
        "1_wire_authorization": "Autoryzacja 1-Wire",
        "access group": "",
        "access groups": "",
        "access level": "Poziom dostępu",
        "accessories": "Akcesoria",
        "action": "Działanie",
        "action date": "Data działania",
        "assigned package": "Przypisany pakiet",
        "attempt count": "Liczba prób",
        "attribute": "Atrybut",
        "attributes": "Atrybuty",
        "auto sync": "",
        "batch id": "Identyfikator partii",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Firmware BLE",
        "bluetooth_authorization": "Autoryzacja Bluetooth",
        "bootloader": "Bootloader",
        "can_adapter": "Adapter CAN",
        "can adapter name": "Nazwa adaptera CAN",
        "can bootstring": "Bootstring",
        "can oem file package": "Pakiet plików OEM",
        "can oem file vehicle": "Plik OEM pojazdu",
        "can package": "Pakiet CAN",
        "can program number": "Numer programu CAN",
        "can software date": "Data oprogramowania CAN",
        "can type": "Typ CAN",
        "carrier module id": "Identyfikator modułu",
        "carrier revision": "Wersja",
        "carrier serial id": "Seryjny identyfikator",
        "carrier settings filename": "Nazwa pliku ustawień",
        "carrier unit status": "Status",
        "carrier unit type": "Typ jednostki",
        "changed at": "Zmieniono w",
        "change origin": "",
        "changes": "Zmiany",
        "checkbox disabled": {
            "role": "Rola statyczna nie może być edytowana ani usuwana."
        },
        "child company": "<0>Spółka zależna</0><1>{{parentCompany}}</1>",
        "child companies": "Spółki zależne",
        "code": "Kod",
        "company": "Firma",
        "company hierarchy": "Hierarchia firmy",
        "company name": "Nazwa firmy",
        "compatibility": "Kompatybilność",
        "configuration": "Konfiguracja",
        "configuration details": "Szczegóły konfiguracji",
        "configuration type": "",
        "created at": "Utworzony w",
        "created by": "Stworzony przez",
        "date": "Data",
        "description": "Opis",
        "device details": "Szczegóły dotyczące urządzeń",
        "device company": "Firma produkująca urządzenia",
        "device description": "Opis urządzenia",
        "device group": "Grupa urządzeń",
        "device imei": "Numer IMEI urządzenia",
        "device model": "Model urządzenia",
        "device seen at": "Urządzenie widoczne na",
        "device serial": "Numer seryjny urządzenia.",
        "devices": "Urządzenia",
        "devices count": "Liczba urządzeń",
        "Done": "Gotowe",
        "download at": "",
        "download file": "Pobierz plik",
        "dtb": "DTB",
        "edit file": "Edytuj plik",
        "email": "E-mail",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "Gdy tylko grupy zadań zostaną utworzone, będziesz mógł zobaczyć ich listę tutaj",
                    "changes": "Gdy tylko zostaną wprowadzone zmiany, lista będzie widoczna tutaj",
                    "companies": "Gdy tylko firmy zostaną utworzone, lista będzie dostępna tutaj",
                    "configurationChanges": "",
                    "desktopLicenses": "Gdy tylko licencje na komputery desktopowe zostaną utworzone, lista będzie widoczna tutaj",
                    "devices": "Gdy tylko urządzenia zostaną przesłane do FOTA WEB, lista będzie widoczna tutaj",
                    "files": "Gdy tylko pliki zostaną przesłane, będzie można zobaczyć ich listę tutaj",
                    "groups": "Gdy tylko grupy zostaną utworzone, lista będzie widoczna tutaj",
                    "offlineLicenses": "Gdy tylko licencje offline zostaną utworzone, będzie można zobaczyć ich listę tutaj",
                    "permissions": "Gdy tylko użytkownikowi zostaną przypisane uprawnienia, lista będzie widoczna tutaj",
                    "productCodes": "Gdy tylko kody produktów zostaną utworzone, będzie można zobaczyć ich listę tutaj",
                    "roles": "Po utworzeniu ról lista będzie widoczna tutaj",
                    "tasks": "Gdy tylko zadania zostaną utworzone, będziesz mógł zobaczyć ich listę tutaj",
                    "users": "Gdy tylko użytkownicy zostaną dodani, lista będzie widoczna tutaj"
                },
                "title": {
                    "batches": "Tabela grup zadań jest pusta",
                    "changes": "Tabela zmian jest pusta",
                    "companies": "Tabela firm jest pusta",
                    "configurationChanges": "",
                    "desktopLicenses": "Tabela licencji na komputery desktopowe jest pusta",
                    "devices": "Tabela urządzeń jest pusta",
                    "files": "Tabela plików jest pusta",
                    "groups": "Tabela grup jest pusta",
                    "offlineLicenses": "Tabela licencji offline jest pusta",
                    "permissions": "Tabela uprawnień jest pusta",
                    "productCodes": "Tabela kodów produktów jest pusta",
                    "roles": "Tabela ról jest pusta",
                    "tasks": "Tabela zadań jest pusta",
                    "users": "Tabela użytkowników jest pusta"
                }
            },
            "no permission": {
                "description": "Aby uzyskać dostęp, skontaktuj się z administratorem.",
                "title": "Nie masz uprawnień niezbędnych do wyświetlenia tej treści"
            },
            "no results found": {
                "description": "Spróbuj innego słowa kluczowego lub filtra, aby uzyskać wyniki",
                "title": "Nie znaleziono wyników"
            },
            "button": {
                "add": {
                    "companies": "Utwórz firmę",
                    "devices": "Dodaj urządzenie",
                    "files": "Przesyłanie plików",
                    "groups": "Utwórz grupę",
                    "productCodes": "Dodaj kod produktu",
                    "tasks": "Utwórz zadanie",
                    "users": "Zaproś użytkownika"
                },
                "reset view": "Resetuj widok"
            }
        },
        "exausted autoscan limit": "Wyczerpany limit autoscan do",
        "exausted vin parsing limit": "Wyczerpano limit analizowania numerów VIN do",
        "expiration": "Wygaśnięcie",
        "expiration date": "Data wygaśnięcia",
        "expires at": "Wygasa o godz",
        "expiry date": "Data wygaśnięcia",
        "field": "Dziedzina",
        "file": "Plik",
        "file id": "Identyfikator pliku",
        "files": "Pliki",
        "file type": "Typ pliku",
        "filter by": "Filtruj według",
        "firmware": "Firmware",
        "general": "Ogólne",
        "general data": "Dane ogólne",
        "gnss version": "Wersja GNSS",
        "group": "Grupa",
        "groups": "Grupy urządzeń",
        "group vip status": "",
        "gsm number": "Numer GSM",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": "",
                "user sent configuration": ""
            },
            "platform": {
                "fmx platform": "Platforma FMx – modele FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200) i TMT.",
                "ft platform": "<1>Platforma FT</1> – modele FTx i ATx.",
                "legacy platform": "<1>Starsza platforma</1> — modele FM (z wyjątkiem FM4001 i FM3010), FMA i GH (GH4000).",
                "title": "Platforma generująca urządzenia telematyczne"
            },
            "visibility": "<2>Zmiany oznaczone jako <1>Wewnętrzne</1> nie są widoczne dla klientów.</2><2>Ponieważ zmiany w urządzeniach mogą obejmować zarówno dane widoczne, jak i ukryte, <1>nie udostępniaj zrzutów ekranu ani szczegółów w komunikacji zewnętrznej</1>.</2>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "Informacje",
        "interface": "Interfejs",
        "invited by": "Zaproszony przez",
        "items": "elementy",
        "last checked at": "Ostatnia kontrola przeprowadzona w dniu",
        "last sign in": "Ostatnie logowanie",
        "last status update": "Ostatnia aktualizacja statusu",
        "last used at": "Ostatnio używany w",
        "license disabled": "Wyłączone",
        "license enabled": "Włączony",
        "license key": "Klucz licencyjny",
        "license name": "",
        "links": "Linki",
        "manual_geofence_scenarios": "Ręczne scenariusze geofence",
        "message": "Wiadomość",
        "model": "Model",
        "model task type support": {
            "false": "Brak wsparcia",
            "true": "Obsługiwane"
        },
        "modem version": "Wersja modemu",
        "name": "Nazwa",
        "new value": "Nowa wartość",
        "next task": "Następne zadanie",
        "no changes": "Bez zmian.",
        "no company name": "Brak nazwy firmy",
        "no details": "Brak szczegółów",
        "no file": "Brak pliku",
        "no imei available": "Brak dostępnego numeru IMEI",
        "no model": "Brak modelu",
        "no parent company": "Firma nie ma spółki macierzystej.",
        "no tasks": "Urządzenie nie ma żadnych zadań.",
        "number": "Liczba",
        "obd": "OBD",
        "obd chip firmware version": "Wersja firmware OBD chip",
        "of": "z",
        "offline licenses tab disabled": "Licencje offline nie są dostępne dla wyłączonych licencji Desktop.",
        "origin": "",
        "original value": "Oryginalna wartość",
        "other information": "Inne informacje",
        "page of": "strona",
        "parent company": "Firma macierzysta",
        "permission count": "Liczba uprawnień",
        "platform": "Platforma",
        "Price": "Cena",
        "product code": "Kod produktu",
        "program number": "Numer programu",
        "property": "Właściwości",
        "queue": "Kolejka",
        "receiving company": "Firma odbiorcza",
        "revision": "Wersja",
        "role": "Rola",
        "role name": "Nazwa roli",
        "rows per page": "Wierszy na stronie",
        "running": "Wykouje",
        "schedule": "Harmonogram",
        "seen at": "Widziane w",
        "select row": "Wybierz wiersz, aby wyświetlić szczegóły",
        "send sms": "Wysyłanie SMS-ów",
        "serial": "Numer seryjny.",
        "show details": {
            "desktopLicenses": "Pokaż szczegóły licencji na komputery desktopowe",
            "devices": "Pokaż szczegóły urządzenia",
            "batches": "Pokaż szczegóły grupy zadań",
            "tasks": "Pokaż szczegóły zadania",
            "companies": "Pokaż szczegóły firmy"
        },
        "sim": "SIM",
        "size": "Rozmiar",
        "software date": "Data oprogramowania",
        "source company": "Firma źródłowa",
        "spec_id": "Spec ID",
        "status": "Status",
        "status id": "Identyfikator statusu",
        "status name": "Nazwa statusu",
        "supported task types": "Obsługiwane typy zadań",
        "synced at": "",
        "sync mode": "",
        "sync status": "",
        "table columns": "Kolumny tabeli",
        "target company": "Firma docelowa",
        "task id": "Identyfikator zadania",
        "task queue": "Kolejka zadań",
        "tasks": "Zadania",
        "task type": "Typ zadania",
        "tct web support": "Wsparcie internetowe TCT web",
        "total": "Całkowity",
        "type": "Typ",
        "updated at": "Zaktualizowano o",
        "updated by": "Zaktualizowano przez",
        "unknown": "Nieznany",
        "user cannot be deleted": "Nie można usunąć użytkownika.",
        "user cannot be edited": "Użytkownik nie może być edytowany.",
        "user cannot delete himself": "Użytkownik nie może usunąć swojego profilu.",
        "user date statuses": {
            "expired": "Wygasły",
            "expires": "Wygasanie",
            "never expires": "Nigdy nie wygasa",
            "sent": "Wysłano"
        },
        "user email": "Adres e-mail użytkownika",
        "user invitation cannot be cancelled": "Zaproszenia użytkowników nie można anulować.",
        "user invitation cannot be resent": "Zaproszenia dla użytkowników nie można ponownie wysłać.",
        "user sent configuration": "",
        "user statuses": {
            "Active": "Aktywny",
            "Inactive": "Nieaktywny",
            "InvitationExpired": "Wygasłe zaproszenie",
            "InvitationPending": "Oczekujące zaproszenie"
        },
        "users": "Użytkownicy",
        "value from": "Wartość z",
        "value to": "Wartość dla",
        "view all roles": "Zobacz wszystkie ({{count}})",
        "vin": "VIN",
        "vip status": "Status VIP",
        "visibility": "Widoczność"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device details": {
            "configuration": {
                "badge tooltips": {
                    "not supported": "",
                    "sync failed": "",
                    "syncing": ""
                },
                "configuration details": "",
                "mode descriptions": {
                    "Disabled": "",
                    "Enabled": "",
                    "ReportingOnly": ""
                },
                "mode not supported tooltip": "",
                "mode titles": {
                    "Disabled": "",
                    "Enabled": "",
                    "not supported": "",
                    "ReportingOnly": ""
                },
                "overview": "",
                "status titles": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "status tooltips": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "sync history": "",
                "sync status": ""
            }
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "Informacje o uprawnieniach",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "nazwa interfejsu akcesoriów.",
                    "type": "podłączony typ akcesorium."
                },
                "can": {
                    "assigned package": "pakiet OEM przypisany do urządzenia.",
                    "can oem file package": "pakiet OEM zgłoszony podczas ostatniego połączenia.",
                    "can oem file vehicle": "Konfiguracja pojazdu OEM zgłoszona podczas ostatniego połączenia.",
                    "dtb": "",
                    "firmware": "wersja firmware CAN."
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "ostatni otrzymany bootstring adaptera CAN zawierający aktualne dane i numer programu adaptera.",
                    "program number": "numer programu adaptera CAN.",
                    "revision": "",
                    "software date": "data oprogramowania adaptera CAN.",
                    "type": "typ adaptera CAN."
                },
                "configuration overview": {
                    "BluetoothAuthorizationList": "",
                    "MainConfiguration": "",
                    "ManualGeofenceList": "",
                    "OneWireAuthorizationList": ""
                },
                "configuration details": {
                    "1_wire_authorization": "nazwa ostatnio wysłanego pliku z listą autoryzacji 1-Wire.",
                    "bluetooth_authorization": "nazwa ostatnio wysłanego pliku z listą autoryzacji Bluetooth.",
                    "main configuration": "nazwa ostatnio wysłanego głównego pliku konfiguracyjnego.",
                    "manual_geofence_scenarios": "nazwa ostatnio wysłanego pliku z listą ręcznie ustawionych geofence."
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "wersja firmware BLE zgłoszona podczas ostatniego połączenia.",
                    "bluetooth password": "",
                    "bootloader": "wersja bootloadera urządzenia zgłoszona podczas ostatniego połączenia.",
                    "company": "firma będąca właścicielem tego urządzenia.",
                    "configuration": "nazwa ostatnio wysłanego pliku konfiguracyjnego.",
                    "description": "opis urządzenia (definiowany przez użytkownika).",
                    "dtb": "wersja dtb zgłoszona podczas ostatniego połączenia.",
                    "firmware": "wersja firmware urządzenia zgłoszona podczas ostatniego połączenia.",
                    "gnss version": "wersja GNSS zgłoszona podczas ostatniego połączenia.",
                    "group": "grupa urządzeń, do której przypisane jest to urządzenie.",
                    "product code": "kod produktu urządzenia.",
                    "serial": "numer seryjny urządzenia."
                },
                "obd": {
                    "obd chip firmware version": "wersja firmware OBD chip zgłoszona podczas ostatniego połączenia.",
                    "vin": "unikalny 17-znakowy kod identyfikujący konkretny pojazd."
                },
                "sim": {
                    "gsm number": "publiczny numer telefonu powiązany z urządzeniem.",
                    "iccid": "unikalny numer seryjny identyfikujący kartę SIM.",
                    "imsi": "unikalny identyfikator abonenta sieci komórkowej."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "data i godzina utworzenia użytkownika.",
                    "id": "unikalny identyfikator użytkownika.",
                    "invited by": "adres e-mail użytkownika, który utworzył zaproszenie.",
                    "role": "role przypisane użytkownikowi.",
                    "updated at": "data i godzina ostatniej aktualizacji użytkownika."
                }
            }
        },
        "user details": "Szczegóły użytkownika"
    },
    "Task groups": {
        "all": "Wszystkie",
        "bulk type": {
            "CompanyBulkDelete": "Usuń firmę",
            "DeviceBulkCreate": "Dodaj urządzenie",
            "DeviceBulkDelete": "Usuń urządzenie",
            "DeviceBulkUpdate": "Aktualizacja urządzenia",
            "FileBulkDelete": "Usuń plik",
            "GroupBulkDelete": "Usuń grupę",
            "TaskBulkCreate": "Utwórz zadanie",
            "TaskBulkUpdate": "Anuluj zadanie",
            "UserBulkDelete": "Usuń użytkownika"
        },
        "pending approval": "Oczekuje na zatwierdzenie",
        "already approved": "Już zatwierdzony",
        "no approval required": "Nie wymaga zatwierdzenia",
        "total objects": "Całkowita liczba obiektów",
        "total tasks": "Całkowita liczba zadań"
    },
    "Task status": {
        "0": "W toku",
        "1": "Działa",
        "2": "Ukończone",
        "3": "Ukończono z błędami",
        "4": "Anulowano",
        "5": "Nie powiodło się",
        "6": "Wygasły",
        "7": "Oczekiwanie na zatwierdzenie",
        "8": "Weryfikacja",
        "task count": {
            "0": "Zadania oczekujące",
            "1": "Wykonywanie zadań",
            "3": "Zadania zakończone z błędami",
            "5": "Nieudane zadania"
        },
        "verified tooltip title": "Zadanie zostało pomyślnie wykonane i zweryfikowane przez urządzenie."
    },
    "Tasks": {
        "0": "Zadanie znajduje się w kolejce i obecnie oczekuje na realizację.",
        "1": "Zadanie jest obecnie w trakcie realizacji.",
        "2": "Zadanie zostało pomyślnie zakończone.",
        "3": "Zadanie zostało wykonane, ale wystąpiły pewne błędy.",
        "4": "Zadanie zostało anulowane.",
        "5": "Zadanie nie powiodło się.",
        "6": "Zadanie nie zostało wykonane w określonym terminie."
    },
    "Tct": {
        "edit configuration": "Edytuj konfigurację",
        "no editable configurations": "Nie przesłano żadnych edytowalnych konfiguracji",
        "open tct": "Otwórz wersję TCT web",
        "open tct description": "Możesz utworzyć nową konfigurację w wersji TCT web lub edytować istniejący plik konfiguracyjny z FOTA WEB.",
        "select configuration file": "Wybierz plik konfiguracyjny, który chcesz edytować w TCT web.",
        "tct web": "TCT web",
        "tct web disabled description": "TCT web jest dostępny wyłącznie dla firm na poziomie Premium."
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
